var ct = Object.defineProperty;
var dt = (e, t, n) => t in e ? ct(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var oe = (e, t, n) => (dt(e, typeof t != "symbol" ? t + "" : t, n), n);
import "./style.css";
import { defineComponent as f, openBlock as u, createElementBlock as h, Fragment as $, createBlock as k, resolveDynamicComponent as H, mergeProps as w, toHandlers as x, withCtx as B, renderSlot as P, resolveComponent as y, createTextVNode as ut, toDisplayString as ne, defineAsyncComponent as D, createVNode as E, renderList as O, createCommentVNode as S, h as Ee, createElementVNode as Z, normalizeStyle as K, normalizeClass as de, markRaw as pt } from "vue";
const mt = /* @__PURE__ */ new Set(["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"]), ht = (e) => typeof e == "string" && mt.has(e.toLowerCase());
function W(e = {}, t, n) {
  const o = {};
  for (const s in e) {
    if (!e[s] || n && !s.startsWith(t))
      continue;
    const r = n ? s.replace(t, "") : s;
    o[r] = e[s];
  }
  return o;
}
const ft = f({
  name: "dynamic-renderer",
  props: ["TagName", "attributes", "actionAttributes"],
  data() {
    return { isEmptyElement: ht };
  }
}), b = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, s] of t)
    n[o] = s;
  return n;
};
function bt(e, t, n, o, s, r) {
  return e.isEmptyElement(e.TagName) ? (u(), k(H(e.TagName), w({ key: 1 }, e.attributes, x(e.actionAttributes)), null, 16)) : (u(), h($, { key: 0 }, [
    typeof e.TagName == "string" ? (u(), k(H(e.TagName), w({ key: 0 }, e.attributes, x(e.actionAttributes)), {
      default: B(() => [
        P(e.$slots, "default")
      ]),
      _: 3
    }, 16)) : (u(), k(H(e.TagName), w({ key: 1 }, e.attributes, x(e.actionAttributes)), {
      default: B(() => [
        P(e.$slots, "default")
      ]),
      _: 3
    }, 16))
  ], 64));
}
const ue = /* @__PURE__ */ b(ft, [["render", bt]]), hr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ue
}, Symbol.toStringTag, { value: "Module" })), V = "vue", ee = () => {
  switch (V) {
    case "react":
    case "reactNative":
    case "rsc":
      return "className";
    case "svelte":
    case "vue":
    case "solid":
    case "qwik":
    case "angular":
      return "class";
  }
}, gt = f({
  name: "builder-button",
  components: { DynamicRenderer: ue },
  props: [
    "attributes",
    "link",
    "openLinkInNewTab",
    "builderLinkComponent",
    "text"
  ],
  data() {
    return { filterAttrs: W };
  },
  methods: {
    attrs() {
      return {
        ...W(this.attributes, "v-on:", !1),
        [ee()]: `${this.link ? "" : "builder-button"} ${this.attributes[ee()] || ""}`,
        ...this.link ? {
          href: this.link,
          target: this.openLinkInNewTab ? "_blank" : void 0,
          role: "link"
        } : {
          role: "button"
        }
      };
    }
  }
});
function yt(e, t, n, o, s, r) {
  const i = y("dynamic-renderer");
  return u(), k(i, {
    attributes: e.attrs(),
    TagName: e.link ? e.builderLinkComponent || "a" : "button",
    actionAttributes: e.filterAttrs(e.attributes, "v-on:", !0)
  }, {
    default: B(() => [
      ut(ne(e.text), 1)
    ]),
    _: 1
  }, 8, ["attributes", "TagName", "actionAttributes"]);
}
const kt = /* @__PURE__ */ b(gt, [["render", yt]]), vt = Symbol(), ae = {
  Builder: {
    content: null,
    context: {},
    localState: void 0,
    rootSetState() {
    },
    rootState: {},
    apiKey: null,
    apiVersion: void 0,
    componentInfos: {},
    inheritedStyles: {},
    BlocksWrapper: "div",
    BlocksWrapperProps: {}
  },
  key: vt
}, St = Symbol(), Pe = {
  Components: { registeredComponents: {} },
  key: St
};
function Ct(e) {
  var t;
  return {
    ...(t = e.component) == null ? void 0 : t.options,
    ...e.options,
    /**
     * Our built-in components frequently make use of the block, so we provide all of it under `builderBlock`
     */
    builderBlock: e
  };
}
const _ = "[Builder.io]: ", R = {
  log: (...e) => console.log(_, ...e),
  error: (...e) => console.error(_, ...e),
  warn: (...e) => console.warn(_, ...e),
  debug: (...e) => console.debug(_, ...e)
};
function T() {
  return typeof window < "u" && typeof document < "u";
}
const wt = (e) => {
  const t = {};
  return e.forEach((n, o) => {
    t[o] = n;
  }), t;
}, xe = (e) => e instanceof URLSearchParams ? wt(e) : e, Ve = (e) => typeof e == "string" ? e : e instanceof URLSearchParams ? e.toString() : new URLSearchParams(e).toString();
function Tt() {
  return T() && window.self !== window.top;
}
function I(e) {
  return Tt() && // accessing window.location.search is safe here because `isIframe()` is only `true` if we're in a browser.
  Ve(e || window.location.search).indexOf("builder.frameEditing=") !== -1;
}
const $t = () => {
  if (T()) {
    const e = new URL(location.href);
    return e.pathname === "" && (e.pathname = "/"), e;
  } else
    return console.warn("Cannot get location for tracking in non-browser environment"), null;
}, It = () => typeof navigator == "object" && navigator.userAgent || "", Ae = () => {
  const e = It(), t = {
    Android() {
      return e.match(/Android/i);
    },
    BlackBerry() {
      return e.match(/BlackBerry/i);
    },
    iOS() {
      return e.match(/iPhone|iPod/i);
    },
    Opera() {
      return e.match(/Opera Mini/i);
    },
    Windows() {
      return e.match(/IEMobile/i) || e.match(/WPDesktop/i);
    },
    any() {
      return t.Android() || t.BlackBerry() || t.iOS() || t.Opera() || t.Windows() || V === "reactNative";
    }
  }, n = e.match(/Tablet|iPad/i), o = $t();
  return {
    urlPath: o == null ? void 0 : o.pathname,
    host: (o == null ? void 0 : o.host) || (o == null ? void 0 : o.hostname),
    device: n ? "tablet" : t.any() ? "mobile" : "desktop"
  };
}, Rt = ({
  builder: e,
  context: t,
  event: n,
  state: o
}) => Object.entries({
  state: o,
  Builder: e,
  // legacy
  builder: e,
  context: t,
  event: n
}), Et = () => ({
  isEditing: I(),
  isBrowser: T(),
  isServer: !T(),
  getUserAttributes: () => Ae()
}), Pt = (e, {
  isExpression: t = !0
}) => /* we disable this for cases where we definitely don't want a return */ t && !(e.includes(";") || e.includes(" return ") || e.trim().startsWith("return ")) ? `return (${e});` : e, ye = ({
  code: e,
  builder: t,
  context: n,
  event: o,
  localState: s,
  rootSetState: r,
  rootState: i
}) => {
  const a = Rt({
    builder: t,
    context: n,
    event: o,
    state: Be({
      rootState: i,
      localState: s,
      rootSetState: r
    })
  });
  return new Function(...a.map(([l]) => l), e)(...a.map(([, l]) => l));
};
function Be({
  rootState: e,
  localState: t,
  rootSetState: n
}) {
  return new Proxy(e, {
    get: (o, s) => {
      if (t && s in t)
        return t[s];
      const r = o[s];
      return typeof r == "object" && r !== null ? Be({
        rootState: r,
        localState: void 0,
        rootSetState: n ? (i) => {
          o[s] = i, n(o);
        } : void 0
      }) : r;
    },
    set: (o, s, r) => {
      if (t && s in t)
        throw new Error("Writing to local state is not allowed as it is read-only.");
      return o[s] = r, n == null || n(o), !0;
    }
  });
}
const U = (e) => e != null;
function xt() {
  var e;
  return typeof process < "u" && U((e = process == null ? void 0 : process.versions) == null ? void 0 : e.node);
}
const Vt = () => {
  var o;
  if (!xt())
    return !1;
  const e = process.arch === "arm64", t = process.version.startsWith("v20"), n = (o = process.env.NODE_OPTIONS) == null ? void 0 : o.includes("--no-node-snapshot");
  return e && t && !n ? (R.log("Skipping usage of `isolated-vm` to avoid crashes in Node v20 on an arm64 machine.\n    If you would like to use the `isolated-vm` package on this machine, please provide the `NODE_OPTIONS=--no-node-snapshot` config to your Node process.\n    See https://github.com/BuilderIO/builder/blob/main/packages/sdks/README.md#node-v20--m1-macs-apple-silicon-support for more information.\n    "), !0) : !1;
}, At = (e) => (T() || Vt(), ye(e)), A = class A {
  static getCacheKey(t) {
    return JSON.stringify({
      ...t,
      // replace the event with a random number to break cache
      // thats because we can't serialize the event object due to circular refs in DOM node refs.
      event: t.event ? Math.random() : void 0
    });
  }
  static getCachedValue(t) {
    return A.cache.get(t);
  }
  static setCachedValue(t, n) {
    A.cache.size > 20 && A.cache.delete(A.cache.keys().next().value), A.cache.set(t, {
      value: n
    });
  }
};
oe(A, "cacheLimit", 20), oe(A, "cache", /* @__PURE__ */ new Map());
let L = A;
function te({
  code: e,
  context: t,
  localState: n,
  rootState: o,
  rootSetState: s,
  event: r,
  isExpression: i = !0,
  enableCache: a
}) {
  if (e === "")
    return;
  const l = {
    code: Pt(e, {
      isExpression: i
    }),
    builder: Et(),
    context: t,
    event: r,
    rootSetState: s,
    rootState: o,
    localState: n
  };
  if (a) {
    const d = L.getCacheKey(l), m = L.getCachedValue(d);
    if (m)
      return m.value;
  }
  try {
    const d = At(l);
    if (a) {
      const m = L.getCacheKey(l);
      L.setCachedValue(m, d);
    }
    return d;
  } catch (d) {
    R.error("Failed code evaluation: " + d.message, {
      code: e
    });
    return;
  }
}
const q = (e) => JSON.parse(JSON.stringify(e)), We = (e, t, n) => {
  if (Object(e) !== e)
    return e;
  const o = Array.isArray(t) ? t : t.toString().match(/[^.[\]]+/g);
  return o.slice(0, -1).reduce((s, r, i) => Object(s[r]) === s[r] ? s[r] : s[r] = Math.abs(Number(o[i + 1])) >> 0 === +o[i + 1] ? [] : {}, e)[o[o.length - 1]] = n, e;
};
const Bt = ({
  block: e,
  context: t,
  localState: n,
  rootState: o,
  rootSetState: s
}) => {
  if (!e.bindings)
    return e;
  const r = q(e), i = {
    ...r,
    properties: {
      ...r.properties
    },
    actions: {
      ...r.actions
    }
  };
  for (const a in e.bindings) {
    const l = e.bindings[a], d = te({
      code: l,
      localState: n,
      rootState: o,
      rootSetState: s,
      context: t,
      enableCache: !0
    });
    We(i, a, d);
  }
  return i;
};
function Ne({
  block: e,
  context: t,
  shouldEvaluateBindings: n,
  localState: o,
  rootState: s,
  rootSetState: r
}) {
  const i = e;
  return n ? Bt({
    block: i,
    localState: o,
    rootState: s,
    rootSetState: r,
    context: t
  }) : i;
}
function Wt(e, t, n = {}) {
  let o, s, r, i = null, a = 0;
  const l = function() {
    a = n.leading === !1 ? 0 : Date.now(), i = null, r = e.apply(o, s), i || (o = s = null);
  };
  return function() {
    const d = Date.now();
    !a && n.leading === !1 && (a = d);
    const m = t - (d - a);
    return o = this, s = arguments, m <= 0 || m > t ? (i && (clearTimeout(i), i = null), a = d, r = e.apply(o, s), i || (o = s = null)) : !i && n.trailing !== !1 && (i = setTimeout(l, m)), r;
  };
}
function j(e, ...t) {
  const n = Object(e);
  for (let o = 1; o < arguments.length; o++) {
    const s = arguments[o];
    if (s != null)
      for (const r in s)
        Object.prototype.hasOwnProperty.call(s, r) && (n[r] = s[r]);
  }
  return n;
}
const Fe = (e) => e ? e.replace(/([A-Z])/g, (t) => `-${t[0].toLowerCase()}`) : "";
function Nt(e) {
  for (const t of e)
    switch (t.trigger) {
      case "pageLoad":
        Le(t);
        break;
      case "scrollInView":
        Ot(t);
        break;
    }
}
function Oe(e) {
  console.warn(`Cannot animate element: element with ID ${e} not found!`);
}
function Ue(e, t) {
  const n = Ft(e), o = getComputedStyle(t), s = e.steps[0].styles, r = e.steps[e.steps.length - 1].styles, i = [s, r];
  for (const a of i)
    for (const l of n)
      l in a || (a[l] = o[l]);
}
function Ft(e) {
  const t = [];
  for (const n of e.steps)
    for (const o in n.styles)
      t.indexOf(o) === -1 && t.push(o);
  return t;
}
function Le(e) {
  const t = Array.prototype.slice.call(document.getElementsByClassName(e.elementId || e.id || ""));
  if (!t.length) {
    Oe(e.elementId || e.id || "");
    return;
  }
  Array.from(t).forEach((n) => {
    Ue(e, n), n.style.transition = "none", n.style.transitionDelay = "0", j(n.style, e.steps[0].styles), setTimeout(() => {
      n.style.transition = `all ${e.duration}s ${Fe(e.easing)}`, e.delay && (n.style.transitionDelay = e.delay + "s"), j(n.style, e.steps[1].styles), setTimeout(() => {
        n.style.transition = "", n.style.transitionDelay = "";
      }, (e.delay || 0) * 1e3 + e.duration * 1e3 + 100);
    });
  });
}
function Ot(e) {
  const t = Array.prototype.slice.call(document.getElementsByClassName(e.elementId || e.id || ""));
  if (!t.length) {
    Oe(e.elementId || e.id || "");
    return;
  }
  Array.from(t).forEach((n) => {
    Ue(e, n);
    let o = !1, s = !1;
    function r() {
      !o && a(n) ? (o = !0, s = !0, setTimeout(() => {
        j(n.style, e.steps[1].styles), e.repeat || document.removeEventListener("scroll", i), setTimeout(() => {
          s = !1, e.repeat || (n.style.transition = "", n.style.transitionDelay = "");
        }, (e.duration + (e.delay || 0)) * 1e3 + 100);
      })) : e.repeat && o && !s && !a(n) && (o = !1, j(n.style, e.steps[0].styles));
    }
    const i = Wt(r, 200, {
      leading: !1
    });
    function a(m) {
      const c = m.getBoundingClientRect(), p = window.innerHeight, g = (e.thresholdPercent || 0) / 100 * p;
      return c.bottom > g && c.top < p - g;
    }
    const l = e.steps[0].styles;
    function d() {
      j(n.style, l);
    }
    d(), setTimeout(() => {
      n.style.transition = `all ${e.duration}s ${Fe(e.easing)}`, e.delay && (n.style.transitionDelay = e.delay + "s");
    }), document.addEventListener("scroll", i, {
      capture: !0,
      passive: !0
    }), r();
  });
}
const Ut = (e) => e.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase(), Me = (e) => Object.entries(e).map(([n, o]) => {
  if (typeof o == "string")
    return `${Ut(n)}: ${o};`;
}).filter(U), Lt = (e) => Me(e).join(`
`), fr = ({
  mediaQuery: e,
  className: t,
  styles: n
}) => {
  const o = `.${t} {
    ${Lt(n)}
  }`;
  return e ? `${e} {
      ${o}
    }` : o;
};
function Mt({
  style: e
}) {
  return e;
}
const br = ({
  block: e,
  context: t
}) => De(Mt({
  style: e.style || {},
  context: t,
  block: e
}));
function De(e) {
  switch (V) {
    case "svelte":
    case "vue":
    case "solid":
    case "angular":
      return Me(e).join(" ");
    case "qwik":
    case "reactNative":
    case "react":
    case "rsc":
      return e;
  }
}
const Dt = ({
  block: e,
  context: t,
  registeredComponents: n
}) => {
  var r;
  const o = (r = Ne({
    block: e,
    localState: t.localState,
    rootState: t.rootState,
    rootSetState: t.rootSetState,
    context: t.context,
    shouldEvaluateBindings: !1
  }).component) == null ? void 0 : r.name;
  if (!o)
    return null;
  const s = n[o];
  if (s)
    return s;
  console.warn(`
      Could not find a registered component named "${o}". 
      If you registered it, is the file that registered it imported by the file that needs to render it?`);
}, Ht = ({
  block: e,
  context: t
}) => {
  const {
    repeat: n,
    ...o
  } = e;
  if (!(n != null && n.collection))
    return;
  const s = te({
    code: n.collection,
    localState: t.localState,
    rootState: t.rootState,
    rootSetState: t.rootSetState,
    context: t.context,
    enableCache: !0
  });
  if (!Array.isArray(s))
    return;
  const r = n.collection.split(".").pop(), i = n.itemName || (r ? r + "Item" : "item");
  return s.map((l, d) => ({
    context: {
      ...t,
      localState: {
        ...t.localState,
        $index: d,
        $item: l,
        [i]: l,
        [`$${i}Index`]: d
      }
    },
    block: o
  }));
}, jt = (e) => e && (e.isRSC || ["Core:Button", "Symbol", "Columns", "Form:Form", "Builder: Tabs"].includes(e.name)), Kt = (e) => e && (e.isRSC || ["Symbol", "Columns", "Form:Form", "Builder: Tabs"].includes(e.name)), zt = () => import("./block-styles-VucTuDWS.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component BlockStyles at ./components/block-styles.vue",
    e
  ), e;
}), qt = () => import("./block-wrapper-PSbhfk7Q.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component BlockWrapper at ./components/block-wrapper.vue",
    e
  ), e;
}), Jt = () => import("./component-ref-fp2vR2QJ.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component ComponentRef at ./components/component-ref/component-ref.vue",
    e
  ), e;
}), Gt = () => import("./repeated-block-CJGGYuy2.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component RepeatedBlock at ./components/repeated-block.vue",
    e
  ), e;
}), Yt = () => Promise.resolve().then(() => ln).then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component DynamicDiv at ../dynamic-div.vue",
    e
  ), e;
}), _t = f({
  name: "block",
  components: {
    BlockStyles: D(zt),
    ComponentRef: D(Jt),
    RepeatedBlock: D(Gt),
    BlockWrapper: D(qt),
    DynamicDiv: D(Yt)
  },
  props: ["block", "context", "registeredComponents", "linkComponent"],
  mounted() {
    const e = this.processedBlock.id, t = this.processedBlock.animations;
    t && e && Nt(
      t.map((n) => ({
        ...n,
        elementId: e
      }))
    );
  },
  computed: {
    blockComponent() {
      return Dt({
        block: this.block,
        context: this.context,
        registeredComponents: this.registeredComponents
      });
    },
    repeatItem() {
      return Ht({
        block: this.block,
        context: this.context
      });
    },
    processedBlock() {
      var e;
      return (e = this.block.repeat) != null && e.collection ? this.block : Ne({
        block: this.block,
        localState: this.context.localState,
        rootState: this.context.rootState,
        rootSetState: this.context.rootSetState,
        context: this.context.context,
        shouldEvaluateBindings: !0
      });
    },
    Tag() {
      var t;
      return this.block.tagName === "a" || ((t = this.processedBlock.properties) == null ? void 0 : t.href) || this.processedBlock.href ? this.linkComponent || "a" : this.block.tagName || "div";
    },
    canShowBlock() {
      var n, o;
      if ((n = this.block.repeat) != null && n.collection)
        return !!((o = this.repeatItem) != null && o.length);
      const e = "hide" in this.processedBlock ? this.processedBlock.hide : !1;
      return ("show" in this.processedBlock ? this.processedBlock.show : !0) && !e;
    },
    childrenWithoutParentComponent() {
      var t;
      return !((t = this.blockComponent) != null && t.component) && !this.repeatItem ? this.processedBlock.children ?? [] : [];
    },
    componentRefProps() {
      var e, t, n;
      return {
        blockChildren: this.processedBlock.children ?? [],
        componentRef: (e = this.blockComponent) == null ? void 0 : e.component,
        componentOptions: {
          ...Ct(this.processedBlock),
          builderContext: this.context,
          ...jt(this.blockComponent) ? {
            builderLinkComponent: this.linkComponent
          } : {},
          ...Kt(this.blockComponent) ? {
            builderComponents: this.registeredComponents
          } : {}
        },
        context: this.context,
        linkComponent: this.linkComponent,
        registeredComponents: this.registeredComponents,
        builderBlock: this.processedBlock,
        includeBlockProps: ((t = this.blockComponent) == null ? void 0 : t.noWrap) === !0,
        isInteractive: !((n = this.blockComponent) != null && n.isRSC)
      };
    }
  }
});
function Qt(e, t, n, o, s, r) {
  var c;
  const i = y("block-styles"), a = y("component-ref"), l = y("block", !0), d = y("block-wrapper"), m = y("repeated-block");
  return e.canShowBlock ? (u(), h($, { key: 0 }, [
    E(i, {
      block: e.block,
      context: e.context
    }, null, 8, ["block", "context"]),
    (c = e.blockComponent) != null && c.noWrap ? (u(), k(a, {
      key: 1,
      componentRef: e.componentRefProps.componentRef,
      componentOptions: e.componentRefProps.componentOptions,
      blockChildren: e.componentRefProps.blockChildren,
      context: e.componentRefProps.context,
      registeredComponents: e.componentRefProps.registeredComponents,
      linkComponent: e.componentRefProps.linkComponent,
      builderBlock: e.componentRefProps.builderBlock,
      includeBlockProps: e.componentRefProps.includeBlockProps,
      isInteractive: e.componentRefProps.isInteractive
    }, null, 8, ["componentRef", "componentOptions", "blockChildren", "context", "registeredComponents", "linkComponent", "builderBlock", "includeBlockProps", "isInteractive"])) : (u(), h($, { key: 0 }, [
      e.repeatItem ? (u(!0), h($, { key: 1 }, O(e.repeatItem, (p, v) => (u(), k(m, {
        key: v,
        repeatContext: p.context,
        block: p.block,
        registeredComponents: e.registeredComponents,
        linkComponent: e.linkComponent
      }, null, 8, ["repeatContext", "block", "registeredComponents", "linkComponent"]))), 128)) : (u(), k(d, {
        key: 0,
        Wrapper: e.Tag,
        block: e.processedBlock,
        context: e.context,
        linkComponent: e.linkComponent
      }, {
        default: B(() => [
          E(a, {
            componentRef: e.componentRefProps.componentRef,
            componentOptions: e.componentRefProps.componentOptions,
            blockChildren: e.componentRefProps.blockChildren,
            context: e.componentRefProps.context,
            registeredComponents: e.componentRefProps.registeredComponents,
            linkComponent: e.componentRefProps.linkComponent,
            builderBlock: e.componentRefProps.builderBlock,
            includeBlockProps: e.componentRefProps.includeBlockProps,
            isInteractive: e.componentRefProps.isInteractive
          }, null, 8, ["componentRef", "componentOptions", "blockChildren", "context", "registeredComponents", "linkComponent", "builderBlock", "includeBlockProps", "isInteractive"]),
          (u(!0), h($, null, O(e.childrenWithoutParentComponent, (p, v) => (u(), k(l, {
            key: p.id,
            block: p,
            registeredComponents: e.registeredComponents,
            linkComponent: e.linkComponent,
            context: e.context
          }, null, 8, ["block", "registeredComponents", "linkComponent", "context"]))), 128))
        ]),
        _: 1
      }, 8, ["Wrapper", "block", "context", "linkComponent"]))
    ], 64))
  ], 64)) : S("", !0);
}
const pe = /* @__PURE__ */ b(_t, [["render", Qt]]), gr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pe
}, Symbol.toStringTag, { value: "Module" })), Xt = f({
  name: "builder-blocks-wrapper",
  props: [
    "blocks",
    "parent",
    "path",
    "styleProp",
    "BlocksWrapperProps",
    "BlocksWrapper"
  ],
  computed: {
    className() {
      var e;
      return "builder-blocks" + ((e = this.blocks) != null && e.length ? "" : " no-blocks");
    }
  },
  methods: {
    onClick() {
      var e, t;
      I() && !((e = this.blocks) != null && e.length) && ((t = window.parent) == null || t.postMessage(
        {
          type: "builder.clickEmptyBlocks",
          data: {
            parentElementId: this.parent,
            dataPath: this.path
          }
        },
        "*"
      ));
    },
    onMouseEnter() {
      var e, t;
      I() && !((e = this.blocks) != null && e.length) && ((t = window.parent) == null || t.postMessage(
        {
          type: "builder.hoverEmptyBlocks",
          data: {
            parentElementId: this.parent,
            dataPath: this.path
          }
        },
        "*"
      ));
    }
  }
});
function Zt(e, t, n, o, s, r) {
  return u(), k(H(e.BlocksWrapper), w({
    class: e.className + " component-178o76acnws",
    "builder-path": e.path,
    "builder-parent-id": e.parent,
    style: e.styleProp,
    onClick: (i) => e.onClick(),
    onMouseEnter: (i) => e.onMouseEnter(),
    onKeyPress: (i) => e.onClick()
  }, { ...e.BlocksWrapperProps }), {
    default: B(() => [
      P(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 16, ["class", "builder-path", "builder-parent-id", "style", "onClick", "onMouseEnter", "onKeyPress"]);
}
const en = /* @__PURE__ */ b(Xt, [["render", Zt], ["__scopeId", "data-v-a5b13ef9"]]), tn = f({
  name: "builder-blocks",
  components: { BlocksWrapper: en, Block: pe },
  props: [
    "blocks",
    "parent",
    "path",
    "styleProp",
    "context",
    "linkComponent",
    "registeredComponents"
  ],
  inject: {
    builderContext: ae.key,
    componentsContext: Pe.key
  }
});
function nn(e, t, n, o, s, r) {
  var l, d;
  const i = y("block"), a = y("blocks-wrapper");
  return u(), k(a, {
    blocks: e.blocks,
    parent: e.parent,
    path: e.path,
    styleProp: e.styleProp,
    BlocksWrapper: ((l = e.context) == null ? void 0 : l.BlocksWrapper) || e.builderContext.BlocksWrapper,
    BlocksWrapperProps: ((d = e.context) == null ? void 0 : d.BlocksWrapperProps) || e.builderContext.BlocksWrapperProps
  }, {
    default: B(() => [
      e.blocks ? (u(!0), h($, { key: 0 }, O(e.blocks, (m, c) => (u(), k(i, {
        key: m.id,
        block: m,
        linkComponent: e.linkComponent,
        context: e.context || e.builderContext,
        registeredComponents: e.registeredComponents || e.componentsContext.registeredComponents
      }, null, 8, ["block", "linkComponent", "context", "registeredComponents"]))), 128)) : S("", !0)
    ]),
    _: 1
  }, 8, ["blocks", "parent", "path", "styleProp", "BlocksWrapper", "BlocksWrapperProps"]);
}
const J = /* @__PURE__ */ b(tn, [["render", nn]]), me = f({
  render() {
    return Ee("style", {
      innerHTML: this.styles,
      "data-id": this.id
    });
  },
  name: "inlined-styles",
  props: ["styles", "id"]
}), He = {
  small: {
    min: 320,
    default: 321,
    max: 640
  },
  medium: {
    min: 641,
    default: 642,
    max: 991
  },
  large: {
    min: 990,
    default: 991,
    max: 1200
  }
}, yr = (e, t = He) => `@media (max-width: ${t[e].max}px)`, on = ({
  small: e,
  medium: t
}) => {
  const n = q(He);
  if (!e || !t)
    return n;
  const o = Math.floor(e / 2);
  n.small = {
    max: e,
    min: o,
    default: o + 1
  };
  const s = n.small.max + 1;
  n.medium = {
    max: t,
    min: s,
    default: s + 1
  };
  const r = n.medium.max + 1;
  return n.large = {
    max: 2e3,
    // TODO: decide upper limit
    min: r,
    default: r + 1
  }, n;
}, sn = (e) => `builder-columns ${e}-breakpoints`, rn = f({
  name: "dynamic-div",
  props: []
});
function an(e, t, n, o, s, r) {
  return u(), h("div", null, [
    P(e.$slots, "default")
  ]);
}
const G = /* @__PURE__ */ b(rn, [["render", an]]), ln = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G
}, Symbol.toStringTag, { value: "Module" })), cn = f({
  name: "builder-columns",
  components: {
    InlinedStyles: me,
    DynamicRenderer: ue,
    Blocks: J,
    DynamicDiv: G
  },
  props: [
    "space",
    "columns",
    "stackColumnsAt",
    "builderLinkComponent",
    "reverseColumnsWhenStacked",
    "builderContext",
    "builderBlock",
    "builderComponents"
  ],
  data() {
    return {
      gutterSize: typeof this.space == "number" ? this.space || 0 : 20,
      cols: this.columns || [],
      stackAt: this.stackColumnsAt || "tablet",
      flexDir: this.stackColumnsAt === "never" ? "row" : this.reverseColumnsWhenStacked ? "column-reverse" : "column",
      TARGET: V,
      getColumnsClass: sn
    };
  },
  methods: {
    getTagName(e) {
      return e.link ? this.builderLinkComponent || "a" : "div";
    },
    getWidth(e) {
      var t;
      return ((t = this.cols[e]) == null ? void 0 : t.width) || 100 / this.cols.length;
    },
    getColumnCssWidth(e) {
      const t = this.gutterSize * (this.cols.length - 1) / this.cols.length;
      return `calc(${this.getWidth(e)}% - ${t}px)`;
    },
    getTabletStyle({
      stackedStyle: e,
      desktopStyle: t
    }) {
      return this.stackAt === "tablet" ? e : t;
    },
    getMobileStyle({
      stackedStyle: e,
      desktopStyle: t
    }) {
      return this.stackAt === "never" ? t : e;
    },
    columnsCssVars() {
      return {
        "--flex-dir": this.flexDir,
        "--flex-dir-tablet": this.getTabletStyle({
          stackedStyle: this.flexDir,
          desktopStyle: "row"
        })
      };
    },
    columnCssVars(e) {
      const t = e === 0 ? 0 : this.gutterSize, n = this.getColumnCssWidth(e), o = `${t}px`, s = "100%", r = 0;
      return {
        ...{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch"
        },
        width: n,
        ["margin-left"]: o,
        "--column-width-mobile": this.getMobileStyle({
          stackedStyle: s,
          desktopStyle: n
        }),
        "--column-margin-left-mobile": this.getMobileStyle({
          stackedStyle: r,
          desktopStyle: o
        }),
        "--column-width-tablet": this.getTabletStyle({
          stackedStyle: s,
          desktopStyle: n
        }),
        "--column-margin-left-tablet": this.getTabletStyle({
          stackedStyle: r,
          desktopStyle: o
        })
      };
    },
    getWidthForBreakpointSize(e) {
      var n, o;
      return on(
        ((o = (n = this.builderContext.content) == null ? void 0 : n.meta) == null ? void 0 : o.breakpoints) || {}
      )[e].max;
    },
    columnsStyles() {
      return `
        @media (max-width: ${this.getWidthForBreakpointSize("medium")}px) {
          .${this.builderBlock.id}-breakpoints {
            flex-direction: var(--flex-dir-tablet);
            align-items: stretch;
          }

          .${this.builderBlock.id}-breakpoints > .builder-column {
            width: var(--column-width-tablet) !important;
            margin-left: var(--column-margin-left-tablet) !important;
          }
        }

        @media (max-width: ${this.getWidthForBreakpointSize("small")}px) {
          .${this.builderBlock.id}-breakpoints {
            flex-direction: var(--flex-dir);
            align-items: stretch;
          }

          .${this.builderBlock.id}-breakpoints > .builder-column {
            width: var(--column-width-mobile) !important;
            margin-left: var(--column-margin-left-mobile) !important;
          }
        },
      `;
    },
    getAttributes(e, t) {
      return {
        ...e.link ? {
          href: e.link
        } : {},
        [ee()]: "builder-column",
        style: De(this.columnCssVars(t))
      };
    }
  }
});
function dn(e, t, n, o, s, r) {
  var d;
  const i = y("inlined-styles"), a = y("blocks"), l = y("dynamic-renderer");
  return u(), h("div", w({
    class: e.getColumnsClass((d = e.builderBlock) == null ? void 0 : d.id) + " div-t9spj7joih",
    style: e.columnsCssVars()
  }, {}), [
    e.TARGET !== "reactNative" ? (u(), k(i, {
      key: 0,
      id: "builderio-columns",
      styles: e.columnsStyles()
    }, null, 8, ["styles"])) : S("", !0),
    (u(!0), h($, null, O(e.columns, (m, c) => (u(), k(l, {
      key: c,
      TagName: e.getTagName(m),
      actionAttributes: {},
      attributes: e.getAttributes(m, c)
    }, {
      default: B(() => [
        E(a, {
          path: `component.options.columns.${c}.blocks`,
          parent: e.builderBlock.id,
          styleProp: {
            flexGrow: "1"
          },
          context: e.builderContext,
          registeredComponents: e.builderComponents,
          linkComponent: e.builderLinkComponent,
          blocks: m.blocks
        }, null, 8, ["path", "parent", "context", "registeredComponents", "linkComponent", "blocks"])
      ]),
      _: 2
    }, 1032, ["TagName", "attributes"]))), 128))
  ], 16);
}
const un = /* @__PURE__ */ b(cn, [["render", dn], ["__scopeId", "data-v-4878b55f"]]), pn = f({
  name: "builder-fragment-component",
  props: []
});
function mn(e, t, n, o, s, r) {
  return u(), h("span", null, [
    P(e.$slots, "default")
  ]);
}
const hn = /* @__PURE__ */ b(pn, [["render", mn]]);
function ke(e) {
  return e.replace(/http(s)?:/, "");
}
function fn(e = "", t, n) {
  const o = new RegExp("([?&])" + t + "=.*?(&|$)", "i"), s = e.indexOf("?") !== -1 ? "&" : "?";
  return e.match(o) ? e.replace(o, "$1" + t + "=" + encodeURIComponent(n) + "$2") : e + s + t + "=" + encodeURIComponent(n);
}
function bn(e, t) {
  if (!e || !(e != null && e.match(/cdn\.shopify\.com/)) || !t)
    return e;
  if (t === "master")
    return ke(e);
  const n = e.match(/(_\d+x(\d+)?)?(\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?)/i);
  if (n) {
    const o = e.split(n[0]), s = n[3], r = t.match("x") ? t : `${t}x`;
    return ke(`${o[0]}_${r}${s}`);
  }
  return null;
}
function se(e) {
  if (!e)
    return e;
  const t = [100, 200, 400, 800, 1200, 1600, 2e3];
  if (e.match(/builder\.io/)) {
    let n = e;
    const o = Number(e.split("?width=")[1]);
    return isNaN(o) || (n = `${n} ${o}w`), t.filter((s) => s !== o).map((s) => `${fn(e, "width", s)} ${s}w`).concat([n]).join(", ");
  }
  return e.match(/cdn\.shopify\.com/) ? t.map((n) => [bn(e, `${n}x${n}`), n]).filter(([n]) => !!n).map(([n, o]) => `${n} ${o}w`).concat([e]).join(", ") : e;
}
const gn = f({
  name: "builder-image",
  props: [
    "image",
    "src",
    "srcset",
    "noWebp",
    "aspectRatio",
    "altText",
    "backgroundPosition",
    "backgroundSize",
    "className",
    "sizes",
    "builderBlock",
    "fitContent"
  ],
  computed: {
    srcSetToUse() {
      var n;
      const t = this.image || this.src;
      if (!t || // We can auto add srcset for cdn.builder.io and shopify
      // images, otherwise you can supply this prop manually
      !(t.match(/builder\.io/) || t.match(/cdn\.shopify\.com/)))
        return this.srcset;
      if (this.srcset && ((n = this.image) != null && n.includes("builder.io/api/v1/image"))) {
        if (!this.srcset.includes(this.image.split("?")[0]))
          return console.debug("Removed given srcset"), se(t);
      } else if (this.image && !this.srcset)
        return se(t);
      return se(t);
    },
    webpSrcSet() {
      var e;
      return (e = this.srcSetToUse) != null && e.match(/builder\.io/) && !this.noWebp ? this.srcSetToUse.replace(/\?/g, "?format=webp&") : "";
    },
    aspectRatioCss() {
      const e = {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: "0px",
        top: "0px"
      };
      return this.aspectRatio ? e : void 0;
    }
  }
}), yn = ["srcset"], kn = ["alt", "role", "src", "srcset", "sizes"], vn = {
  key: 2,
  class: "div-20351ewpue7-2"
};
function Sn(e, t, n, o, s, r) {
  var i, a, l, d, m, c;
  return u(), h($, null, [
    Z("picture", null, [
      e.webpSrcSet ? (u(), h("source", {
        key: 0,
        type: "image/webp",
        srcset: e.webpSrcSet
      }, null, 8, yn)) : S("", !0),
      Z("img", {
        loading: "lazy",
        alt: e.altText,
        role: e.altText ? void 0 : "presentation",
        style: K({
          objectPosition: e.backgroundPosition || "center",
          objectFit: e.backgroundSize || "cover",
          ...e.aspectRatioCss
        }),
        class: de(
          "builder-image" + (e.className ? " " + e.className : "") + " img-20351ewpue7"
        ),
        src: e.image,
        srcset: e.srcSetToUse,
        sizes: e.sizes
      }, null, 14, kn)
    ]),
    e.aspectRatio && !((a = (i = e.builderBlock) == null ? void 0 : i.children) != null && a.length && e.fitContent) ? (u(), h("div", {
      key: 0,
      class: "builder-image-sizer div-20351ewpue7",
      style: K({
        paddingTop: e.aspectRatio * 100 + "%"
      })
    }, null, 4)) : S("", !0),
    (d = (l = e.builderBlock) == null ? void 0 : l.children) != null && d.length && e.fitContent ? P(e.$slots, "default", { key: 1 }, void 0, !0) : S("", !0),
    !e.fitContent && ((c = (m = e.builderBlock) == null ? void 0 : m.children) != null && c.length) ? (u(), h("div", vn, [
      P(e.$slots, "default", {}, void 0, !0)
    ])) : S("", !0)
  ], 64);
}
const Cn = /* @__PURE__ */ b(gn, [["render", Sn], ["__scopeId", "data-v-5dee860d"]]), wn = f({
  name: "builder-section-component",
  props: ["attributes", "maxWidth"],
  data() {
    return { filterAttrs: W };
  }
});
function Tn(e, t, n, o, s, r) {
  return u(), h("section", w({
    style: {
      width: "100%",
      alignSelf: "stretch",
      flexGrow: 1,
      boxSizing: "border-box",
      maxWidth: e.maxWidth || 1200,
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      marginLeft: "auto",
      marginRight: "auto"
    }
  }, e.filterAttrs(e.attributes, "v-on:", !1), x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    P(e.$slots, "default")
  ], 16);
}
const $n = /* @__PURE__ */ b(wn, [["render", Tn]]), In = (e) => {
  if (e === "localhost" || e === "127.0.0.1")
    return e;
  const t = e.split(".");
  return t.length > 2 ? t.slice(1).join(".") : e;
}, je = ({
  name: e,
  canTrack: t
}) => {
  var n;
  try {
    return t ? (n = document.cookie.split("; ").find((o) => o.startsWith(`${e}=`))) == null ? void 0 : n.split("=")[1] : void 0;
  } catch (o) {
    R.warn("[COOKIE] GET error: ", (o == null ? void 0 : o.message) || o);
    return;
  }
}, Ke = async (e) => je(e), Rn = (e) => e.map(([t, n]) => n ? `${t}=${n}` : t).filter(U).join("; "), En = [["secure", ""], ["SameSite", "None"]], Pn = ({
  name: e,
  value: t,
  expires: n
}) => {
  const s = (T() ? location.protocol === "https:" : !0) ? En : [[]], r = n ? [["expires", n.toUTCString()]] : [[]], i = [[e, t], ...r, ["path", "/"], ["domain", In(window.location.hostname)], ...s];
  return Rn(i);
}, ze = async ({
  name: e,
  value: t,
  expires: n,
  canTrack: o
}) => {
  try {
    if (!o)
      return;
    const s = Pn({
      name: e,
      value: t,
      expires: n
    });
    document.cookie = s;
  } catch (s) {
    R.warn("[COOKIE] SET error: ", (s == null ? void 0 : s.message) || s);
  }
}, xn = "builder.tests", he = (e) => `${xn}.${e}`, Vn = ({
  contentId: e
}) => Ke({
  name: he(e),
  canTrack: !0
}), An = ({
  contentId: e
}) => je({
  name: he(e),
  canTrack: !0
}), Bn = ({
  contentId: e,
  value: t
}) => ze({
  name: he(e),
  value: t,
  canTrack: !0
}), qe = (e) => U(e.id) && U(e.variations) && Object.keys(e.variations).length > 0, Wn = ({
  id: e,
  variations: t
}) => {
  var s;
  let n = 0;
  const o = Math.random();
  for (const r in t) {
    const i = (s = t[r]) == null ? void 0 : s.testRatio;
    if (n += i, o < n)
      return r;
  }
  return e;
}, Je = (e) => {
  const t = Wn(e);
  return Bn({
    contentId: e.id,
    value: t
  }).catch((n) => {
    R.error("could not store A/B test variation: ", n);
  }), t;
}, Ge = ({
  item: e,
  testGroupId: t
}) => {
  const n = e.variations[t];
  return t === e.id || // handle edge-case where `testGroupId` points to non-existing variation
  !n ? {
    testVariationId: e.id,
    testVariationName: "Default"
  } : {
    data: n.data,
    testVariationId: n.id,
    testVariationName: n.name || (n.id === e.id ? "Default" : "")
  };
}, Nn = ({
  item: e,
  canTrack: t
}) => {
  if (!t)
    return e;
  if (!e)
    return;
  if (!qe(e))
    return e;
  const n = An({
    contentId: e.id
  }) || Je({
    variations: e.variations,
    id: e.id
  }), o = Ge({
    item: e,
    testGroupId: n
  });
  return {
    ...e,
    ...o
  };
}, Fn = async ({
  item: e,
  canTrack: t
}) => {
  if (!t || !qe(e))
    return e;
  const o = await Vn({
    contentId: e.id
  }) || Je({
    variations: e.variations,
    id: e.id
  }), s = Ge({
    item: e,
    testGroupId: o
  });
  return {
    ...e,
    ...s
  };
}, z = (e) => U(e) ? e : !0, On = {
  name: "Core:Button",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F81a15681c3e74df09677dfc57a615b13",
  defaultStyles: {
    // TODO: make min width more intuitive and set one
    appearance: "none",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "25px",
    paddingRight: "25px",
    backgroundColor: "#000000",
    color: "white",
    borderRadius: "4px",
    textAlign: "center",
    cursor: "pointer"
  },
  inputs: [{
    name: "text",
    type: "text",
    defaultValue: "Click me!",
    bubble: !0
  }, {
    name: "link",
    type: "url",
    bubble: !0
  }, {
    name: "openLinkInNewTab",
    type: "boolean",
    defaultValue: !1,
    friendlyName: "Open link in new tab"
  }],
  static: !0,
  noWrap: !0
}, Un = {
  // TODO: ways to statically preprocess JSON for references, functions, etc
  name: "Columns",
  isRSC: !0,
  inputs: [{
    name: "columns",
    type: "array",
    broadcast: !0,
    subFields: [{
      name: "blocks",
      type: "array",
      hideFromUI: !0,
      defaultValue: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto",
            minHeight: "20px",
            minWidth: "20px",
            overflow: "hidden"
          }
        },
        component: {
          name: "Image",
          options: {
            image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
            backgroundPosition: "center",
            backgroundSize: "cover",
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<p>Enter some text...</p>"
          }
        }
      }]
    }, {
      name: "width",
      type: "number",
      hideFromUI: !0,
      helperText: "Width %, e.g. set to 50 to fill half of the space"
    }, {
      name: "link",
      type: "url",
      helperText: "Optionally set a url that clicking this column will link to"
    }],
    defaultValue: [{
      blocks: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto",
            minHeight: "20px",
            minWidth: "20px",
            overflow: "hidden"
          }
        },
        component: {
          name: "Image",
          options: {
            image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
            backgroundPosition: "center",
            backgroundSize: "cover",
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<p>Enter some text...</p>"
          }
        }
      }]
    }, {
      blocks: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto",
            minHeight: "20px",
            minWidth: "20px",
            overflow: "hidden"
          }
        },
        component: {
          name: "Image",
          options: {
            image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
            backgroundPosition: "center",
            backgroundSize: "cover",
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<p>Enter some text...</p>"
          }
        }
      }]
    }],
    onChange: (e) => {
      function t() {
        n.forEach((o) => {
          o.delete("width");
        });
      }
      const n = e.get("columns");
      Array.isArray(n) && n.find((s) => s.get("width")) && (n.find((r) => !r.get("width")) || n.reduce((a, l) => a + l.get("width"), 0) !== 100) && t();
    }
  }, {
    name: "space",
    type: "number",
    defaultValue: 20,
    helperText: "Size of gap between columns",
    advanced: !0
  }, {
    name: "stackColumnsAt",
    type: "string",
    defaultValue: "tablet",
    helperText: "Convert horizontal columns to vertical at what device size",
    enum: ["tablet", "mobile", "never"],
    advanced: !0
  }, {
    name: "reverseColumnsWhenStacked",
    type: "boolean",
    defaultValue: !1,
    helperText: "When stacking columns for mobile devices, reverse the ordering",
    advanced: !0
  }]
}, Ln = {
  name: "Fragment",
  static: !0,
  hidden: !0,
  canHaveChildren: !0,
  noWrap: !0
}, Mn = {
  name: "Image",
  static: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
  defaultStyles: {
    position: "relative",
    minHeight: "20px",
    minWidth: "20px",
    overflow: "hidden"
  },
  canHaveChildren: !0,
  inputs: [{
    name: "image",
    type: "file",
    bubble: !0,
    allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
    required: !0,
    defaultValue: "https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F72c80f114dc149019051b6852a9e3b7a",
    onChange: (e) => {
      e.delete("srcset"), e.delete("noWebp");
      function n(i, a = 6e4) {
        return new Promise((l, d) => {
          const m = document.createElement("img");
          let c = !1;
          m.onload = () => {
            c = !0, l(m);
          }, m.addEventListener("error", (p) => {
            console.warn("Image load failed", p.error), d(p.error);
          }), m.src = i, setTimeout(() => {
            c || d(new Error("Image load timed out"));
          }, a);
        });
      }
      function o(i) {
        return Math.round(i * 1e3) / 1e3;
      }
      const s = e.get("image"), r = e.get("aspectRatio");
      if (fetch(s).then((i) => i.blob()).then((i) => {
        i.type.includes("svg") && e.set("noWebp", !0);
      }), s && (!r || r === 0.7041))
        return n(s).then((i) => {
          const a = e.get("aspectRatio");
          e.get("image") === s && (!a || a === 0.7041) && i.width && i.height && (e.set("aspectRatio", o(i.height / i.width)), e.set("height", i.height), e.set("width", i.width));
        });
    }
  }, {
    name: "backgroundSize",
    type: "text",
    defaultValue: "cover",
    enum: [{
      label: "contain",
      value: "contain",
      helperText: "The image should never get cropped"
    }, {
      label: "cover",
      value: "cover",
      helperText: "The image should fill it's box, cropping when needed"
    }]
  }, {
    name: "backgroundPosition",
    type: "text",
    defaultValue: "center",
    enum: ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
  }, {
    name: "altText",
    type: "string",
    helperText: "Text to display when the user has images off"
  }, {
    name: "height",
    type: "number",
    hideFromUI: !0
  }, {
    name: "width",
    type: "number",
    hideFromUI: !0
  }, {
    name: "sizes",
    type: "string",
    hideFromUI: !0
  }, {
    name: "srcset",
    type: "string",
    hideFromUI: !0
  }, {
    name: "lazy",
    type: "boolean",
    defaultValue: !0,
    hideFromUI: !0
  }, {
    name: "fitContent",
    type: "boolean",
    helperText: "When child blocks are provided, fit to them instead of using the image's aspect ratio",
    defaultValue: !0
  }, {
    name: "aspectRatio",
    type: "number",
    helperText: "This is the ratio of height/width, e.g. set to 1.5 for a 300px wide and 200px tall photo. Set to 0 to not force the image to maintain it's aspect ratio",
    advanced: !0,
    defaultValue: 0.7041
  }]
}, Dn = {
  name: "Core:Section",
  static: !0,
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F682efef23ace49afac61748dd305c70a",
  inputs: [{
    name: "maxWidth",
    type: "number",
    defaultValue: 1200
  }, {
    name: "lazyLoad",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    description: "Only render this section when in view"
  }],
  defaultStyles: {
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "50px",
    paddingBottom: "50px",
    marginTop: "0px",
    width: "100vw",
    marginLeft: "calc(50% - 50vw)"
  },
  canHaveChildren: !0,
  defaultChildren: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        textAlign: "center"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<p><b>I am a section! My content keeps from getting too wide, so that it's easy to read even on big screens.</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur</p>"
      }
    }
  }]
}, Hn = {
  name: "Slot",
  isRSC: !0,
  description: "Allow child blocks to be inserted into this content when used as a Symbol",
  docsLink: "https://www.builder.io/c/docs/symbols-with-blocks",
  image: "https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F3aad6de36eae43b59b52c85190fdef56",
  // Maybe wrap this for canHaveChildren so bind children to this hm
  inputs: [{
    name: "name",
    type: "string",
    required: !0,
    defaultValue: "children"
  }]
}, jn = f({
  name: "builder-slot",
  components: { Blocks: J },
  props: ["builderContext", "name"]
});
function Kn(e, t, n, o, s, r) {
  var a, l, d;
  const i = y("blocks");
  return u(), h("div", w(
    { style: {
      pointerEvents: "auto"
    } },
    !((a = e.builderContext.context) != null && a.symbolId) && {
      "builder-slot": e.name
    }
  ), [
    E(i, {
      parent: (l = e.builderContext.context) == null ? void 0 : l.symbolId,
      path: `symbol.data.${e.name}`,
      context: e.builderContext,
      blocks: (d = e.builderContext.rootState) == null ? void 0 : d[e.name]
    }, null, 8, ["parent", "path", "context", "blocks"])
  ], 16);
}
const zn = /* @__PURE__ */ b(jn, [["render", Kn]]), qn = {
  name: "Symbol",
  noWrap: !0,
  static: !0,
  isRSC: !0,
  inputs: [{
    name: "symbol",
    type: "uiSymbol"
  }, {
    name: "dataOnly",
    helperText: "Make this a data symbol that doesn't display any UI",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    hideFromUI: !0
  }, {
    name: "inheritState",
    helperText: "Inherit the parent component state and data",
    type: "boolean",
    defaultValue: !1,
    advanced: !0
  }, {
    name: "renderToLiquid",
    helperText: "Render this symbols contents to liquid. Turn off to fetch with javascript and use custom targeting",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    hideFromUI: !0
  }, {
    name: "useChildren",
    hideFromUI: !0,
    type: "boolean"
  }]
}, re = {
  "@type": "@builder.io/sdk:Element",
  responsiveStyles: {
    large: {
      paddingLeft: "20px",
      paddingRight: "20px",
      paddingTop: "10px",
      paddingBottom: "10px",
      minWidth: "100px",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      cursor: "pointer",
      userSelect: "none"
    }
  },
  component: {
    name: "Text",
    options: {
      text: "New tab"
    }
  }
}, ie = {
  "@type": "@builder.io/sdk:Element",
  responsiveStyles: {
    large: {
      height: "200px",
      display: "flex",
      marginTop: "20px",
      flexDirection: "column"
    }
  },
  component: {
    name: "Text",
    options: {
      text: "New tab content "
    }
  }
}, Jn = {
  name: "Builder: Tabs",
  inputs: [{
    name: "tabs",
    type: "list",
    broadcast: !0,
    subFields: [{
      name: "label",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [re]
    }, {
      name: "content",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [ie]
    }],
    defaultValue: [{
      label: [{
        ...re,
        component: {
          name: "Text",
          options: {
            text: "Tab 1"
          }
        }
      }],
      content: [{
        ...ie,
        component: {
          name: "Text",
          options: {
            text: "Tab 1 content"
          }
        }
      }]
    }, {
      label: [{
        ...re,
        component: {
          name: "Text",
          options: {
            text: "Tab 2"
          }
        }
      }],
      content: [{
        ...ie,
        component: {
          name: "Text",
          options: {
            text: "Tab 2 content"
          }
        }
      }]
    }]
  }, {
    name: "activeTabStyle",
    type: "uiStyle",
    helperText: "CSS styles for the active tab",
    defaultValue: {
      backgroundColor: "rgba(0, 0, 0, 0.1)"
    }
  }, {
    name: "defaultActiveTab",
    type: "number",
    helperText: 'Default tab to open to. Set to "1" for the first tab, "2" for the second, or choose "0" for none',
    defaultValue: 1,
    advanced: !0
  }, {
    name: "collapsible",
    type: "boolean",
    helperText: "If on, clicking an open tab closes it so no tabs are active",
    defaultValue: !1,
    advanced: !0
  }, {
    name: "tabHeaderLayout",
    type: "enum",
    helperText: "Change the layout of the tab headers (uses justify-content)",
    defaultValue: "flex-start",
    enum: [{
      label: "Center",
      value: "center"
    }, {
      label: "Space between",
      value: "space-between"
    }, {
      label: "Space around",
      value: "space-around"
    }, {
      label: "Left",
      value: "flex-start"
    }, {
      label: "Right",
      value: "flex-end"
    }]
  }]
}, Gn = f({
  name: "builder-tabs",
  components: { Blocks: J },
  props: [
    "defaultActiveTab",
    "tabs",
    "activeTabStyle",
    "tabHeaderLayout",
    "collapsible",
    "builderBlock",
    "builderContext",
    "builderComponents",
    "builderLinkComponent"
  ],
  data() {
    return { activeTab: this.defaultActiveTab ? this.defaultActiveTab - 1 : 0 };
  },
  methods: {
    activeTabContent(e) {
      return this.tabs && this.tabs[e].content;
    },
    getActiveTabStyle(e) {
      return this.activeTab === e ? this.activeTabStyle : {};
    }
  }
}), Yn = ["onClick"], _n = { key: 0 };
function Qn(e, t, n, o, s, r) {
  const i = y("blocks");
  return u(), h("div", null, [
    Z("div", {
      class: "builder-tabs-wrap",
      style: K({
        display: "flex",
        flexDirection: "row",
        justifyContent: e.tabHeaderLayout || "flex-start",
        overflow: "auto"
      })
    }, [
      (u(!0), h($, null, O(e.tabs, (a, l) => (u(), h("span", {
        key: l,
        class: de(`builder-tab-wrap ${e.activeTab === l ? "builder-tab-active" : ""}`),
        style: K(e.getActiveTabStyle(l)),
        onClick: (d) => {
          l === e.activeTab && e.collapsible ? e.activeTab = -1 : e.activeTab = l;
        }
      }, [
        E(i, {
          parent: e.builderBlock.id,
          path: `component.options.tabs.${l}.label`,
          blocks: a.label,
          context: e.builderContext,
          registeredComponents: e.builderComponents,
          linkComponent: e.builderLinkComponent
        }, null, 8, ["parent", "path", "blocks", "context", "registeredComponents", "linkComponent"])
      ], 14, Yn))), 128))
    ], 4),
    e.activeTabContent(e.activeTab) ? (u(), h("div", _n, [
      E(i, {
        parent: e.builderBlock.id,
        path: `component.options.tabs.${e.activeTab}.content`,
        blocks: e.activeTabContent(e.activeTab),
        context: e.builderContext,
        registeredComponents: e.builderComponents,
        linkComponent: e.builderLinkComponent
      }, null, 8, ["parent", "path", "blocks", "context", "registeredComponents", "linkComponent"])
    ])) : S("", !0)
  ]);
}
const Xn = /* @__PURE__ */ b(Gn, [["render", Qn]]), Zn = {
  name: "Text",
  static: !0,
  isRSC: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-text_fields-24px%20(1).svg?alt=media&token=12177b73-0ee3-42ca-98c6-0dd003de1929",
  inputs: [{
    name: "text",
    type: "html",
    required: !0,
    autoFocus: !0,
    bubble: !0,
    defaultValue: "Enter some text..."
  }],
  defaultStyles: {
    lineHeight: "normal",
    height: "auto",
    textAlign: "center"
  }
}, eo = f({
  name: "builder-text",
  props: ["text"]
}), to = ["innerHTML"];
function no(e, t, n, o, s, r) {
  var i;
  return u(), h("div", {
    class: "builder-text",
    innerHTML: ((i = e.text) == null ? void 0 : i.toString()) || "",
    style: {
      outline: "none"
    }
  }, null, 8, to);
}
const oo = /* @__PURE__ */ b(eo, [["render", no]]), so = {
  name: "Custom Code",
  static: !0,
  requiredPermissions: ["editCode"],
  inputs: [{
    name: "code",
    type: "html",
    required: !0,
    defaultValue: "<p>Hello there, I am custom HTML code!</p>",
    code: !0
  }, {
    name: "replaceNodes",
    type: "boolean",
    helperText: "Preserve server rendered dom nodes",
    advanced: !0
  }, {
    name: "scriptsClientOnly",
    type: "boolean",
    defaultValue: !1,
    helperText: "Only print and run scripts on the client. Important when scripts influence DOM that could be replaced when client loads",
    advanced: !0
  }]
}, ro = f({
  name: "builder-custom-code",
  props: ["replaceNodes", "code"],
  data() {
    return { scriptsInserted: [], scriptsRun: [] };
  },
  mounted() {
    var t;
    if (!((t = this.$refs.elementRef) != null && t.getElementsByTagName) || typeof window > "u")
      return;
    const e = this.$refs.elementRef.getElementsByTagName("script");
    for (let n = 0; n < e.length; n++) {
      const o = e[n];
      if (o.src) {
        if (this.scriptsInserted.includes(o.src))
          continue;
        this.scriptsInserted.push(o.src);
        const s = document.createElement("script");
        s.async = !0, s.src = o.src, document.head.appendChild(s);
      } else if (!o.type || [
        "text/javascript",
        "application/javascript",
        "application/ecmascript"
      ].includes(o.type)) {
        if (this.scriptsRun.includes(o.innerText))
          continue;
        try {
          this.scriptsRun.push(o.innerText), new Function(o.innerText)();
        } catch (s) {
          console.warn("`CustomCode`: Error running script:", s);
        }
      }
    }
  }
}), io = ["innerHTML"];
function ao(e, t, n, o, s, r) {
  return u(), h("div", {
    ref: "elementRef",
    class: de("builder-custom-code" + (e.replaceNodes ? " replace-nodes" : "")),
    innerHTML: e.code
  }, null, 10, io);
}
const lo = /* @__PURE__ */ b(ro, [["render", ao]]), co = {
  name: "Embed",
  static: !0,
  inputs: [{
    name: "url",
    type: "url",
    required: !0,
    defaultValue: "",
    helperText: "e.g. enter a youtube url, google map, etc",
    onChange: (e) => {
      const t = e.get("url");
      if (t)
        return e.set("content", "Loading..."), fetch(`https://iframe.ly/api/iframely?url=${t}&api_key=ae0e60e78201a3f2b0de4b`).then((o) => o.json()).then((o) => {
          e.get("url") === t && (o.html ? e.set("content", o.html) : e.set("content", "Invalid url, please try another"));
        }).catch((o) => {
          e.set("content", "There was an error embedding this URL, please try again or another URL");
        });
      e.delete("content");
    }
  }, {
    name: "content",
    type: "html",
    defaultValue: '<div style="padding: 20px; text-align: center">(Choose an embed URL)<div>',
    hideFromUI: !0
  }]
}, uo = ["text/javascript", "application/javascript", "application/ecmascript"], po = (e) => uo.includes(e.type), mo = f({
  name: "builder-embed",
  props: ["content"],
  data() {
    return { scriptsInserted: [], scriptsRun: [], ranInitFn: !1 };
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.$refs.elem && !this.ranInitFn && (this.ranInitFn = !0, this.findAndRunScripts());
      },
      immediate: !0
    }
  },
  computed: {
    onUpdateHook0() {
      return {
        0: this.$refs.elem,
        1: this.ranInitFn
      };
    }
  },
  methods: {
    findAndRunScripts() {
      if (!this.$refs.elem || !this.$refs.elem.getElementsByTagName)
        return;
      const e = this.$refs.elem.getElementsByTagName("script");
      for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n.src && !this.scriptsInserted.includes(n.src)) {
          this.scriptsInserted.push(n.src);
          const o = document.createElement("script");
          o.async = !0, o.src = n.src, document.head.appendChild(o);
        } else if (po(n) && !this.scriptsRun.includes(n.innerText))
          try {
            this.scriptsRun.push(n.innerText), new Function(n.innerText)();
          } catch (o) {
            console.warn("`Embed`: Error running script:", o);
          }
      }
    }
  }
}), ho = ["innerHTML"];
function fo(e, t, n, o, s, r) {
  return u(), h("div", {
    class: "builder-embed",
    ref: "elem",
    innerHTML: e.content
  }, null, 8, ho);
}
const bo = /* @__PURE__ */ b(mo, [["render", fo]]), go = {
  name: "Form:Form",
  // editableTags: ['builder-form-error']
  defaults: {
    responsiveStyles: {
      large: {
        marginTop: "15px",
        paddingBottom: "15px"
      }
    }
  },
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fef36d2a846134910b64b88e6d18c5ca5",
  inputs: [{
    name: "sendSubmissionsTo",
    type: "string",
    // TODO: save to builder data and user can download as csv
    // TODO: easy for mode too or computed add/remove fields form mode
    // so you can edit details and high level mode at same time...
    // Later - more integrations like mailchimp
    // /api/v1/form-submit?to=mailchimp
    enum: [{
      label: "Send to email",
      value: "email",
      helperText: "Send form submissions to the email address of your choosing"
    }, {
      label: "Custom",
      value: "custom",
      helperText: "Handle where the form requests go manually with a little code, e.g. to your own custom backend"
    }],
    defaultValue: "email"
  }, {
    name: "sendSubmissionsToEmail",
    type: "string",
    required: !0,
    // TODO: required: () => options.get("sendSubmissionsTo") === "email"
    defaultValue: "your@email.com",
    showIf: 'options.get("sendSubmissionsTo") === "email"'
  }, {
    name: "sendWithJs",
    type: "boolean",
    helperText: "Set to false to use basic html form action",
    defaultValue: !0,
    showIf: 'options.get("sendSubmissionsTo") === "custom"'
  }, {
    name: "name",
    type: "string",
    defaultValue: "My form"
    // advanced: true
  }, {
    name: "action",
    type: "string",
    helperText: "URL to send the form data to",
    showIf: 'options.get("sendSubmissionsTo") === "custom"'
  }, {
    name: "contentType",
    type: "string",
    defaultValue: "application/json",
    advanced: !0,
    // TODO: do automatically if file input
    enum: ["application/json", "multipart/form-data", "application/x-www-form-urlencoded"],
    showIf: 'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'
  }, {
    name: "method",
    type: "string",
    showIf: 'options.get("sendSubmissionsTo") === "custom"',
    defaultValue: "POST",
    advanced: !0
  }, {
    name: "previewState",
    type: "string",
    // TODO: persist: false flag
    enum: ["unsubmitted", "sending", "success", "error"],
    defaultValue: "unsubmitted",
    helperText: 'Choose a state to edit, e.g. choose "success" to show what users see on success and edit the message',
    showIf: 'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'
  }, {
    name: "successUrl",
    type: "url",
    helperText: "Optional URL to redirect the user to on form submission success",
    showIf: 'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'
  }, {
    name: "resetFormOnSubmit",
    type: "boolean",
    showIf: "options.get('sendSubmissionsTo') === 'custom' && options.get('sendWithJs') === true",
    advanced: !0
  }, {
    name: "successMessage",
    type: "uiBlocks",
    hideFromUI: !0,
    defaultValue: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Thanks!</span>"
        }
      }
    }]
  }, {
    name: "validate",
    type: "boolean",
    defaultValue: !0,
    advanced: !0
  }, {
    name: "errorMessagePath",
    type: "text",
    advanced: !0,
    helperText: 'Path to where to get the error message from in a JSON response to display to the user, e.g. "error.message" for a response like { "error": { "message": "this username is taken" }}'
  }, {
    name: "errorMessage",
    type: "uiBlocks",
    hideFromUI: !0,
    defaultValue: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      bindings: {
        "component.options.text": "state.formErrorMessage || block.component.options.text"
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Form submission error :( Please check your answers and try again</span>"
        }
      }
    }]
  }, {
    name: "sendingMessage",
    type: "uiBlocks",
    hideFromUI: !0,
    defaultValue: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Sending...</span>"
        }
      }
    }]
  }, {
    name: "customHeaders",
    type: "map",
    valueType: {
      type: "string"
    },
    advanced: !0,
    showIf: 'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'
  }],
  noWrap: !0,
  canHaveChildren: !0,
  defaultChildren: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<span>Enter your name</span>"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Form:Input",
      options: {
        name: "name",
        placeholder: "Jane Doe"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<span>Enter your email</span>"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Form:Input",
      options: {
        name: "email",
        placeholder: "jane@doe.com"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Form:SubmitButton",
      options: {
        text: "Submit"
      }
    }
  }]
}, yo = ["production", "qa", "test", "development", "dev", "cdn-qa", "cloud", "fast", "cdn2", "cdn-prod"], ko = () => {
  const e = process.env.NODE_ENV || "production";
  return yo.includes(e) ? e : "production";
}, vo = (e, t, n) => {
  const o = String.prototype.split.call(t, /[,[\].]+?/).filter(Boolean).reduce((s, r) => s != null ? s[r] : s, e);
  return o === void 0 || o === e ? n : o;
}, So = f({
  name: "builder-form-component",
  components: { Block: pe, Blocks: J },
  props: [
    "builderContext",
    "previewState",
    "sendWithJs",
    "sendSubmissionsTo",
    "action",
    "customHeaders",
    "contentType",
    "sendSubmissionsToEmail",
    "name",
    "method",
    "errorMessagePath",
    "resetFormOnSubmit",
    "successUrl",
    "validate",
    "attributes",
    "builderBlock",
    "builderComponents",
    "builderLinkComponent",
    "errorMessage",
    "sendingMessage",
    "successMessage"
  ],
  data() {
    return {
      formState: "unsubmitted",
      responseData: null,
      formErrorMessage: "",
      filterAttrs: W
    };
  },
  methods: {
    mergeNewRootState(e) {
      var n, o;
      const t = {
        ...this.builderContext.rootState,
        ...e
      };
      this.builderContext.rootSetState ? (o = (n = this.builderContext).rootSetState) == null || o.call(n, t) : this.builderContext.rootState = t;
    },
    submissionState() {
      return I() && this.previewState || this.formState;
    },
    onSubmit(e) {
      var n;
      const t = this.sendWithJs || this.sendSubmissionsTo === "email";
      if (this.sendSubmissionsTo === "zapier")
        e.preventDefault();
      else if (t) {
        if (!(this.action || this.sendSubmissionsTo === "email")) {
          e.preventDefault();
          return;
        }
        e.preventDefault();
        const o = e.currentTarget, s = this.customHeaders || {};
        let r;
        const i = new FormData(o), a = Array.from(
          e.currentTarget.querySelectorAll("input,select,textarea")
        ).filter((c) => !!c.name).map((c) => {
          let p;
          const v = c.name;
          if (c instanceof HTMLInputElement)
            if (c.type === "radio") {
              if (c.checked)
                return p = c.name, {
                  key: v,
                  value: p
                };
            } else if (c.type === "checkbox")
              p = c.checked;
            else if (c.type === "number" || c.type === "range") {
              const g = c.valueAsNumber;
              isNaN(g) || (p = g);
            } else
              c.type === "file" ? p = c.files : p = c.value;
          else
            p = c.value;
          return {
            key: v,
            value: p
          };
        });
        let l = this.contentType;
        if (this.sendSubmissionsTo === "email" && (l = "multipart/form-data"), Array.from(a).forEach(({ value: c }) => {
          (c instanceof File || Array.isArray(c) && c[0] instanceof File || c instanceof FileList) && (l = "multipart/form-data");
        }), l !== "application/json")
          r = i;
        else {
          const c = {};
          Array.from(a).forEach(({ value: p, key: v }) => {
            We(c, v, p);
          }), r = JSON.stringify(c);
        }
        l && l !== "multipart/form-data" && (t && ((n = this.action) != null && n.includes("zapier.com")) || (s["content-type"] = l));
        const d = new CustomEvent("presubmit", {
          detail: {
            body: r
          }
        });
        if (this.$refs.formRef && (this.$refs.formRef.dispatchEvent(d), d.defaultPrevented))
          return;
        this.formState = "sending";
        const m = `${ko() === "dev" ? "http://localhost:5000" : "https://builder.io"}/api/v1/form-submit?apiKey=${this.builderContext.apiKey}&to=${btoa(
          this.sendSubmissionsToEmail || ""
        )}&name=${encodeURIComponent(this.name || "")}`;
        fetch(
          this.sendSubmissionsTo === "email" ? m : this.action,
          {
            body: r,
            headers: s,
            method: this.method || "post"
          }
        ).then(
          async (c) => {
            let p;
            const v = c.headers.get("content-type");
            if (v && v.indexOf("application/json") !== -1 ? p = await c.json() : p = await c.text(), !c.ok && this.errorMessagePath) {
              let g = vo(p, this.errorMessagePath);
              g && (typeof g != "string" && (g = JSON.stringify(g)), this.formErrorMessage = g, this.mergeNewRootState({
                formErrorMessage: g
              }));
            }
            if (this.responseData = p, this.formState = c.ok ? "success" : "error", c.ok) {
              const g = new CustomEvent("submit:success", {
                detail: {
                  res: c,
                  body: p
                }
              });
              if (this.$refs.formRef) {
                if (this.$refs.formRef.dispatchEvent(g), g.defaultPrevented)
                  return;
                this.resetFormOnSubmit !== !1 && this.$refs.formRef.reset();
              }
              if (this.successUrl)
                if (this.$refs.formRef) {
                  const N = new CustomEvent("route", {
                    detail: {
                      url: this.successUrl
                    }
                  });
                  this.$refs.formRef.dispatchEvent(N), N.defaultPrevented || (location.href = this.successUrl);
                } else
                  location.href = this.successUrl;
            }
          },
          (c) => {
            const p = new CustomEvent("submit:error", {
              detail: {
                error: c
              }
            });
            this.$refs.formRef && (this.$refs.formRef.dispatchEvent(p), p.defaultPrevented) || (this.responseData = c, this.formState = "error");
          }
        );
      }
    }
  }
}), Co = ["validate", "action", "method", "name"], wo = {
  key: 3,
  class: "builder-form-error-text pre-3i4ezorcfhi"
};
function To(e, t, n, o, s, r) {
  var l;
  const i = y("block"), a = y("blocks");
  return u(), h("form", w({
    validate: e.validate,
    ref: "formRef",
    action: !e.sendWithJs && e.action,
    method: e.method,
    name: e.name,
    onSubmit: t[0] || (t[0] = (d) => e.onSubmit(d))
  }, e.filterAttrs(e.attributes, "v-on:", !1), x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    e.builderBlock && e.builderBlock.children ? (u(!0), h($, { key: 0 }, O((l = e.builderBlock) == null ? void 0 : l.children, (d, m) => (u(), k(i, {
      key: `form-block-${e.idx}`,
      block: d,
      context: e.builderContext,
      registeredComponents: e.builderComponents,
      linkComponent: e.builderLinkComponent
    }, null, 8, ["block", "context", "registeredComponents", "linkComponent"]))), 128)) : S("", !0),
    e.submissionState() === "error" ? (u(), k(a, {
      key: 1,
      path: "errorMessage",
      blocks: e.errorMessage,
      context: e.builderContext
    }, null, 8, ["blocks", "context"])) : S("", !0),
    e.submissionState() === "sending" ? (u(), k(a, {
      key: 2,
      path: "sendingMessage",
      blocks: e.sendingMessage,
      context: e.builderContext
    }, null, 8, ["blocks", "context"])) : S("", !0),
    e.submissionState() === "error" && e.responseData ? (u(), h("pre", wo, ne(JSON.stringify(e.responseData, null, 2)), 1)) : S("", !0),
    e.submissionState() === "success" ? (u(), k(a, {
      key: 4,
      path: "successMessage",
      blocks: e.successMessage,
      context: e.builderContext
    }, null, 8, ["blocks", "context"])) : S("", !0)
  ], 16, Co);
}
const $o = /* @__PURE__ */ b(So, [["render", To], ["__scopeId", "data-v-1573388b"]]), Io = {
  name: "Form:Input",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fad6f37889d9e40bbbbc72cdb5875d6ca",
  inputs: [
    {
      name: "type",
      type: "text",
      enum: ["text", "number", "email", "url", "checkbox", "radio", "range", "date", "datetime-local", "search", "tel", "time", "file", "month", "week", "password", "color", "hidden"],
      defaultValue: "text"
    },
    {
      name: "name",
      type: "string",
      required: !0,
      helperText: 'Every input in a form needs a unique name describing what it takes, e.g. "email"'
    },
    {
      name: "placeholder",
      type: "string",
      defaultValue: "Hello there",
      helperText: "Text to display when there is no value"
    },
    // TODO: handle value vs default value automatically like ng-model
    {
      name: "defaultValue",
      type: "string"
    },
    {
      name: "value",
      type: "string",
      advanced: !0
    },
    {
      name: "required",
      type: "boolean",
      helperText: "Is this input required to be filled out to submit a form",
      defaultValue: !1
    }
  ],
  noWrap: !0,
  static: !0,
  defaultStyles: {
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    borderRadius: "3px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#ccc"
  }
}, Ro = f({
  name: "builder-form-input-component",
  props: [
    "attributes",
    "defaultValue",
    "placeholder",
    "type",
    "name",
    "value",
    "required"
  ],
  data() {
    return { isEditing: I, filterAttrs: W };
  }
}), Eo = ["placeholder", "type", "name", "value", "defaultValue", "required"];
function Po(e, t, n, o, s, r) {
  return u(), h("input", w({
    key: e.isEditing() && e.defaultValue ? e.defaultValue : "default-key",
    placeholder: e.placeholder,
    type: e.type,
    name: e.name,
    value: e.value,
    defaultValue: e.defaultValue,
    required: e.required
  }, e.filterAttrs(e.attributes, "v-on:", !1), x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), null, 16, Eo);
}
const xo = /* @__PURE__ */ b(Ro, [["render", Po]]), Vo = {
  name: "Form:Select",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F83acca093fb24aaf94dee136e9a4b045",
  defaultStyles: {
    alignSelf: "flex-start"
  },
  inputs: [{
    name: "options",
    type: "list",
    required: !0,
    subFields: [{
      name: "value",
      type: "text",
      required: !0
    }, {
      name: "name",
      type: "text"
    }],
    defaultValue: [{
      value: "option 1"
    }, {
      value: "option 2"
    }]
  }, {
    name: "name",
    type: "string",
    required: !0,
    helperText: 'Every select in a form needs a unique name describing what it gets, e.g. "email"'
  }, {
    name: "defaultValue",
    type: "string"
  }, {
    name: "value",
    type: "string",
    advanced: !0
  }, {
    name: "required",
    type: "boolean",
    defaultValue: !1
  }],
  static: !0,
  noWrap: !0
}, Ao = f({
  name: "builder-select-component",
  props: ["attributes", "value", "defaultValue", "name", "options"],
  data() {
    return { isEditing: I, filterAttrs: W };
  }
}), Bo = ["value", "defaultValue", "name"], Wo = ["value"];
function No(e, t, n, o, s, r) {
  return u(), h("select", w({
    value: e.value,
    key: e.isEditing() && e.defaultValue ? e.defaultValue : "default-key",
    defaultValue: e.defaultValue,
    name: e.name
  }, e.filterAttrs(e.attributes, "v-on:", !1), x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    (u(!0), h($, null, O(e.options, (i, a) => (u(), h("option", {
      key: `${i.name}-${a}`,
      value: i.value
    }, ne(i.name || i.value), 9, Wo))), 128))
  ], 16, Bo);
}
const Fo = /* @__PURE__ */ b(Ao, [["render", No]]), Oo = {
  name: "Form:SubmitButton",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fdf2820ffed1f4349a94c40b3221f5b98",
  defaultStyles: {
    appearance: "none",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "25px",
    paddingRight: "25px",
    backgroundColor: "#3898EC",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer"
  },
  inputs: [{
    name: "text",
    type: "text",
    defaultValue: "Click me"
  }],
  static: !0,
  noWrap: !0
  // TODO: optional children? maybe as optional form input
  // that only shows if advanced setting is flipped
  // TODO: defaultChildren
  // canHaveChildren: true,
}, Uo = f({
  name: "builder-submit-button",
  props: ["attributes", "text"],
  data() {
    return { filterAttrs: W };
  }
});
function Lo(e, t, n, o, s, r) {
  return u(), h("button", w({ type: "submit" }, e.filterAttrs(e.attributes, "v-on:", !1), x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), ne(e.text), 17);
}
const Mo = /* @__PURE__ */ b(Uo, [["render", Lo]]), Do = {
  // friendlyName?
  name: "Raw:Img",
  hideFromInsertMenu: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
  inputs: [{
    name: "image",
    bubble: !0,
    type: "file",
    allowedFileTypes: ["jpeg", "jpg", "png", "svg", "gif", "webp"],
    required: !0
  }],
  noWrap: !0,
  static: !0
}, Ho = f({
  name: "builder-img-component",
  props: [
    "backgroundSize",
    "backgroundPosition",
    "imgSrc",
    "altText",
    "image",
    "attributes"
  ],
  data() {
    return { isEditing: I, filterAttrs: W };
  }
}), jo = ["alt", "src"];
function Ko(e, t, n, o, s, r) {
  return u(), h("img", w({
    style: {
      objectFit: e.backgroundSize || "cover",
      objectPosition: e.backgroundPosition || "center"
    },
    key: e.isEditing() && e.imgSrc || "default-key",
    alt: e.altText,
    src: e.imgSrc || e.image
  }, e.filterAttrs(e.attributes, "v-on:", !1), x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), null, 16, jo);
}
const zo = /* @__PURE__ */ b(Ho, [["render", Ko]]), qo = {
  name: "Video",
  canHaveChildren: !0,
  defaultStyles: {
    minHeight: "20px",
    minWidth: "20px"
  },
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-videocam-24px%20(1).svg?alt=media&token=49a84e4a-b20e-4977-a650-047f986874bb",
  inputs: [{
    name: "video",
    type: "file",
    allowedFileTypes: ["mp4"],
    bubble: !0,
    defaultValue: "https://cdn.builder.io/o/assets%2FYJIGb4i01jvw0SRdL5Bt%2Fd27731a526464deba0016216f5f9e570%2Fcompressed?apiKey=YJIGb4i01jvw0SRdL5Bt&token=d27731a526464deba0016216f5f9e570&alt=media&optimized=true",
    required: !0
  }, {
    name: "posterImage",
    type: "file",
    allowedFileTypes: ["jpeg", "png"],
    helperText: "Image to show before the video plays"
  }, {
    name: "autoPlay",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "controls",
    type: "boolean",
    defaultValue: !1
  }, {
    name: "muted",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "loop",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "playsInline",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "fit",
    type: "text",
    defaultValue: "cover",
    enum: ["contain", "cover", "fill", "auto"]
  }, {
    name: "preload",
    type: "text",
    defaultValue: "metadata",
    enum: ["auto", "metadata", "none"]
  }, {
    name: "fitContent",
    type: "boolean",
    helperText: "When child blocks are provided, fit to them instead of using the aspect ratio",
    defaultValue: !0,
    advanced: !0
  }, {
    name: "position",
    type: "text",
    defaultValue: "center",
    enum: ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
  }, {
    name: "height",
    type: "number",
    advanced: !0
  }, {
    name: "width",
    type: "number",
    advanced: !0
  }, {
    name: "aspectRatio",
    type: "number",
    advanced: !0,
    defaultValue: 0.7004048582995948
  }, {
    name: "lazyLoad",
    type: "boolean",
    helperText: 'Load this video "lazily" - as in only when a user scrolls near the video. Recommended for optmized performance and bandwidth consumption',
    defaultValue: !0,
    advanced: !0
  }]
}, Jo = f({
  name: "builder-video",
  props: [
    "autoPlay",
    "muted",
    "controls",
    "loop",
    "playsInline",
    "preload",
    "attributes",
    "fit",
    "position",
    "aspectRatio",
    "video",
    "posterImage",
    "lazyLoad",
    "fitContent",
    "builderBlock"
  ],
  computed: {
    videoProps() {
      return {
        ...this.autoPlay === !0 ? {
          autoPlay: !0
        } : {},
        ...this.muted === !0 ? {
          muted: !0
        } : {},
        ...this.controls === !0 ? {
          controls: !0
        } : {},
        ...this.loop === !0 ? {
          loop: !0
        } : {},
        ...this.playsInline === !0 ? {
          playsInline: !0
        } : {}
      };
    },
    spreadProps() {
      return {
        ...this.videoProps
      };
    }
  }
}), Go = { style: {
  position: "relative"
} }, Yo = ["preload", "src", "poster"], _o = ["src"], Qo = {
  key: 1,
  style: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  }
}, Xo = {
  key: 2,
  style: {
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%"
  }
};
function Zo(e, t, n, o, s, r) {
  var i, a, l, d, m, c, p;
  return u(), h("div", Go, [
    Z("video", w({
      class: "builder-video",
      preload: e.preload || "metadata",
      style: {
        width: "100%",
        height: "100%",
        ...(i = e.attributes) == null ? void 0 : i.style,
        objectFit: e.fit,
        objectPosition: e.position,
        // Hack to get object fit to work as expected and
        // not have the video overflow
        zIndex: 2,
        borderRadius: "1px",
        ...e.aspectRatio ? {
          position: "absolute"
        } : null
      },
      src: e.video || "no-src",
      poster: e.posterImage
    }, e.spreadProps), [
      e.lazyLoad ? S("", !0) : (u(), h("source", {
        key: 0,
        type: "video/mp4",
        src: e.video
      }, null, 8, _o))
    ], 16, Yo),
    e.aspectRatio && !(e.fitContent && ((l = (a = e.builderBlock) == null ? void 0 : a.children) != null && l.length)) ? (u(), h("div", {
      key: 0,
      style: K({
        width: "100%",
        paddingTop: e.aspectRatio * 100 + "%",
        pointerEvents: "none",
        fontSize: "0px"
      })
    }, null, 4)) : S("", !0),
    (m = (d = e.builderBlock) == null ? void 0 : d.children) != null && m.length && e.fitContent ? (u(), h("div", Qo, [
      P(e.$slots, "default")
    ])) : S("", !0),
    (p = (c = e.builderBlock) == null ? void 0 : c.children) != null && p.length && !e.fitContent ? (u(), h("div", Xo, [
      P(e.$slots, "default")
    ])) : S("", !0)
  ]);
}
const es = /* @__PURE__ */ b(Jo, [["render", Zo]]), ts = () => [{
  component: lo,
  ...so
}, {
  component: bo,
  ...co
}, {
  component: $o,
  ...go
}, {
  component: xo,
  ...Io
}, {
  component: Mo,
  ...Oo
}, {
  component: Fo,
  ...Vo
}, {
  component: zo,
  ...Do
}, {
  component: es,
  ...qo
}], ve = () => [{
  component: kt,
  ...On
}, {
  component: un,
  ...Un
}, {
  component: hn,
  ...Ln
}, {
  component: Cn,
  ...Mn
}, {
  component: $n,
  ...Dn
}, {
  component: zn,
  ...Hn
}, {
  component: dr,
  ...qn
}, {
  component: oo,
  ...Zn
}, {
  component: Xn,
  ...Jn
}, ...ts()], ns = (e) => ({
  type: "builder.registerComponent",
  data: le(e)
}), os = (e) => {
  const t = e.toString().trim();
  return `return (${!t.startsWith("function") && !t.startsWith("(") ? "function " : ""}${t}).apply(this, arguments)`;
}, ss = (e) => typeof e == "function" ? os(e) : q(e), le = ({
  inputs: e,
  ...t
}) => ({
  ...q(t),
  inputs: e == null ? void 0 : e.map((n) => Object.entries(n).reduce((o, [s, r]) => ({
    ...o,
    [s]: ss(r)
  }), {}))
}), rs = `function updateCookiesAndStyles(contentId, variants, isHydrationTarget) {
  function getAndSetVariantId() {
    function setCookie(name, value, days) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/' + '; Secure; SameSite=None';
    }
    function getCookie(name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    const cookieName = \`builder.tests.\${contentId}\`;
    const variantInCookie = getCookie(cookieName);
    const availableIDs = variants.map(vr => vr.id).concat(contentId);
    if (variantInCookie && availableIDs.includes(variantInCookie)) {
      return variantInCookie;
    }
    let n = 0;
    const random = Math.random();
    for (let i = 0; i < variants.length; i++) {
      const variant = variants[i];
      const testRatio = variant.testRatio;
      n += testRatio;
      if (random < n) {
        setCookie(cookieName, variant.id);
        return variant.id;
      }
    }
    setCookie(cookieName, contentId);
    return contentId;
  }
  const winningVariantId = getAndSetVariantId();
  const styleEl = document.currentScript?.previousElementSibling;
  if (isHydrationTarget) {
    styleEl.remove();
    const thisScriptEl = document.currentScript;
    thisScriptEl?.remove();
  } else {
    const newStyleStr = variants.concat({
      id: contentId
    }).filter(variant => variant.id !== winningVariantId).map(value => {
      return \`.variant-\${value.id} {  display: none; }
        \`;
    }).join('');
    styleEl.innerHTML = newStyleStr;
  }
}`, is = `function updateVariantVisibility(variantContentId, defaultContentId, isHydrationTarget) {
  if (!navigator.cookieEnabled) {
    return;
  }
  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  const cookieName = \`builder.tests.\${defaultContentId}\`;
  const winningVariant = getCookie(cookieName);
  const parentDiv = document.currentScript?.parentElement;
  const isDefaultContent = variantContentId === defaultContentId;
  const isWinningVariant = winningVariant === variantContentId;
  if (isWinningVariant && !isDefaultContent) {
    parentDiv?.removeAttribute('hidden');
    parentDiv?.removeAttribute('aria-hidden');
  } else if (!isWinningVariant && isDefaultContent) {
    parentDiv?.setAttribute('hidden', 'true');
    parentDiv?.setAttribute('aria-hidden', 'true');
  }
  if (isHydrationTarget) {
    if (!isWinningVariant) {
      parentDiv?.remove();
    }
    const thisScriptEl = document.currentScript;
    thisScriptEl?.remove();
  }
  return;
}`, Ye = "builderIoAbTest", _e = "builderIoRenderContent", Q = (e) => Object.values((e == null ? void 0 : e.variations) || {}).map((t) => ({
  ...t,
  testVariationId: t.id,
  id: e == null ? void 0 : e.id
})), as = ({
  canTrack: e,
  content: t
}) => !(!(Q(t).length > 0) || !e), ls = (e) => e === "react" || e === "reactNative", Qe = ls(V), cs = () => `
  window.${Ye} = ${rs}
  window.${_e} = ${is}
  `, ds = (e, t) => `
  window.${Ye}(
    "${t}",${JSON.stringify(e)}, ${Qe}
  )`, us = ({
  contentId: e,
  variationId: t
}) => `window.${_e}(
    "${t}", "${e}", ${Qe}
  )`, Xe = f({
  render() {
    return Ee("script", {
      innerHTML: this.scriptStr,
      "data-id": this.id
    });
  },
  name: "inlined-script",
  props: ["scriptStr", "id"]
});
function ps() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : globalThis;
}
function ms() {
  const e = ps().fetch;
  if (typeof e > "u")
    throw console.warn(`Builder SDK could not find a global fetch function. Make sure you have a polyfill for fetch in your project. 
      For more information, read https://github.com/BuilderIO/this-package-uses-fetch`), new Error("Builder SDK could not find a global `fetch` function");
  return e;
}
const Ze = ms();
function X(e, t = null, n = ".") {
  return Object.keys(e).reduce((o, s) => {
    const r = e[s], i = [t, s].filter(Boolean).join(n);
    return [typeof r == "object", r !== null, !(Array.isArray(r) && r.length === 0)].every(Boolean) ? {
      ...o,
      ...X(r, i, n)
    } : {
      ...o,
      [i]: r
    };
  }, {});
}
const hs = "v3", Se = "builder.", fs = "options.", et = (e) => {
  if (!e)
    return {};
  const t = xe(e), n = {};
  return Object.keys(t).forEach((o) => {
    if (o.startsWith(Se)) {
      const s = o.replace(Se, "").replace(fs, "");
      n[s] = t[o];
    }
  }), n;
}, bs = () => {
  if (!T())
    return {};
  const e = new URLSearchParams(window.location.search);
  return et(e);
}, Ce = (e) => typeof e == "number" && !isNaN(e) && e >= 0, fe = (e) => {
  const {
    limit: t = 30,
    userAttributes: n,
    query: o,
    model: s,
    apiKey: r,
    enrich: i,
    locale: a,
    apiVersion: l = hs,
    fields: d,
    omit: m,
    offset: c,
    cacheSeconds: p,
    staleCacheSeconds: v,
    sort: g,
    includeUnpublished: N
  } = e;
  if (!r)
    throw new Error("Missing API key");
  if (!["v3"].includes(l))
    throw new Error(`Invalid apiVersion: expected 'v3', received '${l}'`);
  const Y = t !== 1, C = new URL(`https://cdn.builder.io/api/${l}/content/${s}`);
  if (C.searchParams.set("apiKey", r), C.searchParams.set("limit", String(t)), C.searchParams.set("noTraverse", String(Y)), C.searchParams.set("includeRefs", String(!0)), a && C.searchParams.set("locale", a), i && C.searchParams.set("enrich", String(i)), C.searchParams.set("omit", m || "meta.componentsUsed"), d && C.searchParams.set("fields", d), Number.isFinite(c) && c > -1 && C.searchParams.set("offset", String(Math.floor(c))), typeof N == "boolean" && C.searchParams.set("includeUnpublished", String(N)), p && Ce(p) && C.searchParams.set("cacheSeconds", String(p)), v && Ce(v) && C.searchParams.set("staleCacheSeconds", String(v)), g) {
    const F = X({
      sort: g
    });
    for (const M in F)
      C.searchParams.set(M, JSON.stringify(F[M]));
  }
  const lt = {
    ...bs(),
    ...xe(e.options || {})
  }, ge = X(lt);
  for (const F in ge)
    C.searchParams.set(F, String(ge[F]));
  if (n && C.searchParams.set("userAttributes", JSON.stringify(n)), o) {
    const F = X({
      query: o
    });
    for (const M in F)
      C.searchParams.set(M, JSON.stringify(F[M]));
  }
  return C;
}, gs = (e) => "results" in e;
async function be(e) {
  const t = await vs({
    ...e,
    limit: 1
  });
  return t && t[0] || null;
}
const ys = async (e) => {
  const t = fe(e);
  return await (await (e.fetch ?? Ze)(t.href, e.fetchOptions)).json();
}, ks = async (e, t, n = fe(e)) => {
  const o = z(e.canTrack);
  if (n.search.includes("preview="), !o || !(T() || V === "reactNative"))
    return t.results;
  try {
    const s = [];
    for (const r of t.results)
      s.push(await Fn({
        item: r,
        canTrack: o
      }));
    t.results = s;
  } catch (s) {
    R.error("Could not process A/B tests. ", s);
  }
  return t.results;
};
async function vs(e) {
  try {
    const t = fe(e), n = await ys(e);
    return gs(n) ? ks(e, n) : (R.error("Error fetching data. ", {
      url: t,
      content: n,
      options: e
    }), null);
  } catch (t) {
    return R.error("Error fetching data. ", t), null;
  }
}
function Ss(e) {
  const t = e || (T() ? window.location.search : void 0);
  return t ? Ve(t).indexOf("builder.preview=") !== -1 : !1;
}
function Cs() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    const t = Math.random() * 16 | 0;
    return (e == "x" ? t : t & 3 | 8).toString(16);
  });
}
function tt() {
  return Cs().replace(/-/g, "");
}
const nt = "builderSessionId", ws = async ({
  canTrack: e
}) => {
  if (!e)
    return;
  const t = await Ke({
    name: nt,
    canTrack: e
  });
  if (U(t))
    return t;
  {
    const n = Ts();
    return $s({
      id: n,
      canTrack: e
    }), n;
  }
}, Ts = () => tt(), $s = ({
  id: e,
  canTrack: t
}) => ze({
  name: nt,
  value: e,
  canTrack: t
}), ot = () => T() && typeof localStorage < "u" ? localStorage : void 0, Is = ({
  key: e,
  canTrack: t
}) => {
  var n;
  try {
    return t ? (n = ot()) == null ? void 0 : n.getItem(e) : void 0;
  } catch (o) {
    console.debug("[LocalStorage] GET error: ", o);
    return;
  }
}, Rs = ({
  key: e,
  canTrack: t,
  value: n
}) => {
  var o;
  try {
    t && ((o = ot()) == null || o.setItem(e, n));
  } catch (s) {
    console.debug("[LocalStorage] SET error: ", s);
  }
}, st = "builderVisitorId", Es = ({
  canTrack: e
}) => {
  if (!e)
    return;
  const t = Is({
    key: st,
    canTrack: e
  });
  if (U(t))
    return t;
  {
    const n = Ps();
    return xs({
      id: n,
      canTrack: e
    }), n;
  }
}, Ps = () => tt(), xs = ({
  id: e,
  canTrack: t
}) => Rs({
  key: st,
  value: e,
  canTrack: t
}), Vs = async ({
  canTrack: e
}) => {
  if (!e)
    return {
      visitorId: void 0,
      sessionId: void 0
    };
  const t = await ws({
    canTrack: e
  }), n = Es({
    canTrack: e
  });
  return {
    sessionId: t,
    visitorId: n
  };
}, As = async ({
  type: e,
  canTrack: t,
  apiKey: n,
  metadata: o,
  ...s
}) => ({
  type: e,
  data: {
    ...s,
    metadata: {
      url: location.href,
      ...o
    },
    ...await Vs({
      canTrack: t
    }),
    userAttributes: Ae(),
    ownerId: n
  }
});
async function ce(e) {
  if (!e.apiKey) {
    R.error("Missing API key for track call. Please provide your API key.");
    return;
  }
  if (e.canTrack && !I() && (T() || V === "reactNative"))
    return fetch("https://cdn.builder.io/api/v1/track", {
      method: "POST",
      body: JSON.stringify({
        events: [await As(e)]
      }),
      headers: {
        "content-type": "application/json"
      },
      mode: "cors"
    }).catch((t) => {
      console.error("Failed to track: ", t);
    });
}
const kr = (e) => ce({
  ...e,
  canTrack: !0
});
function we(e) {
  return Math.round(e * 1e3) / 1e3;
}
const Bs = (e, t, n = !0) => {
  if (!(e instanceof HTMLElement))
    return null;
  let o = n ? e : e.parentElement;
  do {
    if (!o)
      return null;
    if (t(o))
      return o;
  } while (o = o.parentElement);
  return null;
}, Ws = (e) => Bs(e, (t) => {
  const n = t.getAttribute("builder-id") || t.id;
  return (n == null ? void 0 : n.indexOf("builder-")) === 0;
}), Te = ({
  event: e,
  target: t
}) => {
  const n = t.getBoundingClientRect(), o = e.clientX - n.left, s = e.clientY - n.top, r = we(o / n.width), i = we(s / n.height);
  return {
    x: r,
    y: i
  };
}, Ns = (e) => {
  const t = e.target, n = t && Ws(t), o = (n == null ? void 0 : n.getAttribute("builder-id")) || (n == null ? void 0 : n.id);
  return {
    targetBuilderElement: o || void 0,
    metadata: {
      targetOffset: t ? Te({
        event: e,
        target: t
      }) : void 0,
      builderTargetOffset: n ? Te({
        event: e,
        target: n
      }) : void 0,
      builderElementIndex: n && o ? [].slice.call(document.getElementsByClassName(o)).indexOf(n) : void 0
    }
  };
}, Fs = ["*.beta.builder.io", "beta.builder.io", "builder.io", "localhost", "qa.builder.io"];
function rt(e, t) {
  const n = new URL(t.origin), o = n.hostname;
  return (e || Fs).findIndex((s) => s.startsWith("*.") ? o.endsWith(s.slice(1)) : s === o) > -1;
}
const Os = "1.0.25", $e = {};
function Us(e, t) {
  let n = $e[e];
  if (n || (n = $e[e] = []), n.push(t), T()) {
    const o = {
      type: "builder.register",
      data: {
        type: e,
        info: t
      }
    };
    try {
      parent.postMessage(o, "*"), parent !== window && window.postMessage(o, "*");
    } catch (s) {
      console.debug("Could not postmessage", s);
    }
  }
}
const Ls = () => {
  Us("insertMenu", {
    name: "_default",
    default: !0,
    items: [{
      name: "Box"
    }, {
      name: "Text"
    }, {
      name: "Image"
    }, {
      name: "Columns"
    }, {
      name: "Core:Section"
    }, {
      name: "Core:Button"
    }, {
      name: "Embed"
    }, {
      name: "Custom Code"
    }]
  });
};
let Ie = !1;
const it = (e = {}) => {
  var t, n;
  Ie || (Ie = !0, T() && ((t = window.parent) == null || t.postMessage({
    type: "builder.sdkInfo",
    data: {
      target: V,
      version: Os,
      supportsPatchUpdates: !1,
      // Supports builder-model="..." attribute which is needed to
      // scope our '+ add block' button styling
      supportsAddBlockScoping: !0,
      supportsCustomBreakpoints: !0
    }
  }, "*"), (n = window.parent) == null || n.postMessage({
    type: "builder.updateContent",
    data: {
      options: e
    }
  }, "*"), window.addEventListener("message", (o) => {
    var r, i;
    if (!rt(e.trustedHosts, o))
      return;
    const {
      data: s
    } = o;
    if (s != null && s.type)
      switch (s.type) {
        case "builder.evaluate": {
          const a = s.data.text, l = s.data.arguments || [], d = s.data.id, m = new Function(a);
          let c, p = null;
          try {
            c = m.apply(null, l);
          } catch (v) {
            p = v;
          }
          p ? (r = window.parent) == null || r.postMessage({
            type: "builder.evaluateError",
            data: {
              id: d,
              error: p.message
            }
          }, "*") : c && typeof c.then == "function" ? c.then((v) => {
            var g;
            (g = window.parent) == null || g.postMessage({
              type: "builder.evaluateResult",
              data: {
                id: d,
                result: v
              }
            }, "*");
          }).catch(console.error) : (i = window.parent) == null || i.postMessage({
            type: "builder.evaluateResult",
            data: {
              result: c,
              id: d
            }
          }, "*");
          break;
        }
      }
  })));
}, at = ({
  model: e,
  trustedHosts: t,
  callbacks: n
}) => (o) => {
  if (!rt(t, o))
    return;
  const {
    data: s
  } = o;
  if (s)
    switch (s.type) {
      case "builder.configureSdk": {
        n.configureSdk(s.data);
        break;
      }
      case "builder.triggerAnimation": {
        n.animation(s.data);
        break;
      }
      case "builder.contentUpdate": {
        const r = s.data, i = r.key || r.alias || r.entry || r.modelName, a = r.data;
        i === e && n.contentUpdate(a);
        break;
      }
    }
}, vr = (e, t, n) => {
  if (!T)
    return R.warn("`subscribeToEditor` only works in the browser. It currently seems to be running on the server."), () => {
    };
  it();
  const o = at({
    callbacks: {
      contentUpdate: t,
      animation: () => {
      },
      configureSdk: () => {
      }
    },
    model: e,
    trustedHosts: n == null ? void 0 : n.trustedHosts
  });
  return window.addEventListener("message", o), () => {
    window.removeEventListener("message", o);
  };
}, Ms = (e) => {
  var r;
  const t = e.family + (e.kind && !e.kind.includes("#") ? ", " + e.kind : ""), n = t.split(",")[0], o = e.fileUrl ?? ((r = e == null ? void 0 : e.files) == null ? void 0 : r.regular);
  let s = "";
  if (o && t && n && (s += `
@font-face {
font-family: "${t}";
src: local("${n}"), url('${o}') format('woff2');
font-display: fallback;
font-weight: 400;
}
      `.trim()), e.files)
    for (const i in e.files) {
      if (!(String(Number(i)) === i))
        continue;
      const l = e.files[i];
      l && l !== o && (s += `
@font-face {
font-family: "${t}";
src: url('${l}') format('woff2');
font-display: fallback;
font-weight: ${i};
}
        `.trim());
    }
  return s;
}, Ds = ({
  customFonts: e
}) => {
  var t;
  return ((t = e == null ? void 0 : e.map((n) => Ms(n))) == null ? void 0 : t.join(" ")) || "";
}, Hs = ({
  cssCode: e,
  contentId: t
}) => e ? t ? (e == null ? void 0 : e.replace(/&/g, `div[builder-content-id="${t}"]`)) || "" : e : "", js = `
.builder-button {
  all: unset;
}

.builder-text > p:first-of-type, .builder-text > .builder-paragraph:first-of-type {
  margin: 0;
}
.builder-text > p, .builder-text > .builder-paragraph {
  color: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  font-weight: inherit;
  font-size: inherit;
  text-align: inherit;
  font-family: inherit;
}
`, Ks = (e) => e ? "" : js, zs = (e) => `variant-${e}`, qs = f({
  name: "enable-editor",
  components: { DynamicDiv: G },
  props: [
    "builderContextSignal",
    "canTrack",
    "apiKey",
    "locale",
    "enrich",
    "trustedHosts",
    "model",
    "content",
    "data",
    "showContent",
    "contentWrapper",
    "context",
    "contentWrapperProps"
  ],
  data() {
    return {
      ContentWrapper: this.contentWrapper || "div",
      httpReqsData: {},
      httpReqsPending: {},
      clicked: !1,
      builderContext: ae,
      getWrapperClassName: zs
    };
  },
  provide() {
    const e = this;
    return {
      [ae.key]: e.builderContextSignal
    };
  },
  mounted() {
    (() => {
      var n, o;
      if (T()) {
        if (I() && this.$refs.elementRef && this.$refs.elementRef.dispatchEvent(
          new CustomEvent("initeditingbldr")
        ), this.builderContextSignal.content && z(this.canTrack)) {
          const r = (n = this.builderContextSignal.content) == null ? void 0 : n.testVariationId, i = (o = this.builderContextSignal.content) == null ? void 0 : o.id, a = this.apiKey;
          ce({
            type: "impression",
            canTrack: !0,
            contentId: i,
            apiKey: a,
            variationId: r !== i ? r : void 0
          });
        }
        Ss() && !I() && this.$refs.elementRef && this.$refs.elementRef.dispatchEvent(
          new CustomEvent("initpreviewingbldr")
        );
      }
    })(), (() => {
      this.apiKey || R.error(
        "No API key provided to `RenderContent` component. This can cause issues. Please provide an API key using the `apiKey` prop."
      ), this.evaluateJsCode(), this.runHttpRequests(), this.emitStateUpdate();
    })();
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.content && this.mergeNewContent(this.content);
      },
      immediate: !0
    },
    onUpdateHook1: {
      handler() {
        this.evaluateJsCode();
      },
      immediate: !0
    },
    onUpdateHook2: {
      handler() {
        this.runHttpRequests();
      },
      immediate: !0
    },
    onUpdateHook3: {
      handler() {
        this.emitStateUpdate();
      },
      immediate: !0
    },
    onUpdateHook4: {
      handler() {
        this.data && this.mergeNewRootState(this.data);
      },
      immediate: !0
    },
    onUpdateHook5: {
      handler() {
        this.locale && this.mergeNewRootState({
          locale: this.locale
        });
      },
      immediate: !0
    }
  },
  unmounted() {
    T() && (window.removeEventListener("message", this.processMessage), window.removeEventListener(
      "builder:component:stateChangeListenerActivated",
      this.emitStateUpdate
    ));
  },
  computed: {
    showContentProps() {
      return this.showContent ? {} : {
        hidden: !0,
        "aria-hidden": !0
      };
    },
    onUpdateHook0() {
      return {
        0: this.content
      };
    },
    onUpdateHook1() {
      var e, t;
      return {
        0: (t = (e = this.builderContextSignal.content) == null ? void 0 : e.data) == null ? void 0 : t.jsCode
      };
    },
    onUpdateHook2() {
      var e, t;
      return {
        0: (t = (e = this.builderContextSignal.content) == null ? void 0 : e.data) == null ? void 0 : t.httpRequests
      };
    },
    onUpdateHook3() {
      return {
        0: this.builderContextSignal.rootState
      };
    },
    onUpdateHook4() {
      return {
        0: this.data
      };
    },
    onUpdateHook5() {
      return {
        0: this.locale
      };
    }
  },
  methods: {
    mergeNewRootState(e) {
      var n, o;
      const t = {
        ...this.builderContextSignal.rootState,
        ...e
      };
      this.builderContextSignal.rootSetState ? (o = (n = this.builderContextSignal).rootSetState) == null || o.call(n, t) : this.builderContextSignal.rootState = t;
    },
    mergeNewContent(e) {
      var n, o, s, r, i;
      const t = {
        ...this.builderContextSignal.content,
        ...e,
        data: {
          ...(n = this.builderContextSignal.content) == null ? void 0 : n.data,
          ...e == null ? void 0 : e.data
        },
        meta: {
          ...(o = this.builderContextSignal.content) == null ? void 0 : o.meta,
          ...e == null ? void 0 : e.meta,
          breakpoints: ((s = e == null ? void 0 : e.meta) == null ? void 0 : s.breakpoints) || ((i = (r = this.builderContextSignal.content) == null ? void 0 : r.meta) == null ? void 0 : i.breakpoints)
        }
      };
      this.builderContextSignal.content = t;
    },
    processMessage(e) {
      return at({
        model: this.model,
        trustedHosts: this.trustedHosts,
        callbacks: {
          configureSdk: (t) => {
            var s;
            const { breakpoints: n, contentId: o } = t;
            !o || o !== ((s = this.builderContextSignal.content) == null ? void 0 : s.id) || n && this.mergeNewContent({
              meta: {
                breakpoints: n
              }
            });
          },
          animation: (t) => {
            Le(t);
          },
          contentUpdate: (t) => {
            this.mergeNewContent(t);
          }
        }
      })(e);
    },
    evaluateJsCode() {
      var t, n;
      const e = (n = (t = this.builderContextSignal.content) == null ? void 0 : t.data) == null ? void 0 : n.jsCode;
      e && te({
        code: e,
        context: this.context || {},
        localState: void 0,
        rootState: this.builderContextSignal.rootState,
        rootSetState: this.builderContextSignal.rootSetState,
        /**
         * We don't want to cache the result of the JS code, since it's arbitrary side effect code.
         */
        enableCache: !1
      });
    },
    onClick(e) {
      var t, n;
      if (this.builderContextSignal.content) {
        const o = (t = this.builderContextSignal.content) == null ? void 0 : t.testVariationId, s = (n = this.builderContextSignal.content) == null ? void 0 : n.id;
        ce({
          type: "click",
          canTrack: z(this.canTrack),
          contentId: s,
          apiKey: this.apiKey,
          variationId: o !== s ? o : void 0,
          ...Ns(e),
          unique: !this.clicked
        });
      }
      this.clicked || (this.clicked = !0);
    },
    runHttpRequests() {
      var t, n;
      const e = ((n = (t = this.builderContextSignal.content) == null ? void 0 : t.data) == null ? void 0 : n.httpRequests) ?? {};
      Object.entries(e).forEach(([o, s]) => {
        if (!s || this.httpReqsPending[o] || this.httpReqsData[o] && !I())
          return;
        this.httpReqsPending[o] = !0;
        const r = s.replace(
          /{{([^}]+)}}/g,
          (i, a) => String(
            te({
              code: a,
              context: this.context || {},
              localState: void 0,
              rootState: this.builderContextSignal.rootState,
              rootSetState: this.builderContextSignal.rootSetState,
              enableCache: !0
            })
          )
        );
        Ze(r).then((i) => i.json()).then((i) => {
          this.mergeNewRootState({
            [o]: i
          }), this.httpReqsData[o] = !0;
        }).catch((i) => {
          console.error("error fetching dynamic data", s, i);
        }).finally(() => {
          this.httpReqsPending[o] = !1;
        });
      });
    },
    emitStateUpdate() {
      I() && window.dispatchEvent(
        new CustomEvent(
          "builder:component:stateChange",
          {
            detail: {
              state: q(this.builderContextSignal.rootState),
              ref: {
                name: this.model
              }
            }
          }
        )
      );
    },
    elementRef_onIniteditingbldr(e) {
      window.addEventListener("message", this.processMessage), Ls(), it({
        ...this.locale ? {
          locale: this.locale
        } : {},
        ...this.enrich ? {
          enrich: this.enrich
        } : {},
        ...this.trustedHosts ? {
          trustedHosts: this.trustedHosts
        } : {}
      }), Object.values(
        this.builderContextSignal.componentInfos
      ).forEach((t) => {
        var o;
        const n = ns(t);
        (o = window.parent) == null || o.postMessage(n, "*");
      }), window.addEventListener(
        "builder:component:stateChangeListenerActivated",
        this.emitStateUpdate
      );
    },
    elementRef_onInitpreviewingbldr(e) {
      const t = new URL(location.href).searchParams, n = t.get("builder.preview"), o = t.get(
        `builder.preview.${n}`
      ), s = t.get("apiKey") || t.get("builder.space");
      n === this.model && s === this.apiKey && (!this.content || o === this.content.id) && be({
        model: this.model,
        apiKey: this.apiKey,
        apiVersion: this.builderContextSignal.apiVersion
      }).then((r) => {
        r && this.mergeNewContent(r);
      });
    }
  }
});
function Js(e, t, n, o, s, r) {
  var i, a, l;
  return e.builderContextSignal.content ? (u(), k(H(e.ContentWrapper), w({
    key: 0,
    ref: "elementRef",
    onClick: (d) => e.onClick(d),
    "builder-content-id": (i = e.builderContextSignal.content) == null ? void 0 : i.id,
    "builder-model": e.model,
    class: e.getWrapperClassName(((a = e.content) == null ? void 0 : a.testVariationId) || ((l = e.content) == null ? void 0 : l.id)),
    onIniteditingbldr: (d) => e.elementRef_onIniteditingbldr(d),
    onInitpreviewingbldr: (d) => e.elementRef_onInitpreviewingbldr(d)
  }, { ...e.showContentProps, ...e.contentWrapperProps }), {
    default: B(() => [
      P(e.$slots, "default")
    ]),
    _: 3
  }, 16, ["onClick", "builder-content-id", "builder-model", "class", "onIniteditingbldr", "onInitpreviewingbldr"])) : S("", !0);
}
const Gs = /* @__PURE__ */ b(qs, [["render", Js]]), Ys = f({
  name: "content-styles",
  components: { InlinedStyles: me },
  props: ["cssCode", "contentId", "customFonts", "isNestedRender"],
  data() {
    return {
      injectedStyles: `
${Hs({
        cssCode: this.cssCode,
        contentId: this.contentId
      })}
${Ds({
        customFonts: this.customFonts
      })}
${Ks(this.isNestedRender)}
`.trim()
    };
  }
});
function _s(e, t, n, o, s, r) {
  const i = y("inlined-styles");
  return u(), k(i, {
    id: "builderio-content",
    styles: e.injectedStyles
  }, null, 8, ["styles"]);
}
const Qs = /* @__PURE__ */ b(Ys, [["render", _s]]), Xs = ({
  content: e,
  data: t,
  locale: n
}) => {
  var r, i, a;
  const o = {}, s = ((r = e == null ? void 0 : e.data) == null ? void 0 : r.state) || {};
  return (a = (i = e == null ? void 0 : e.data) == null ? void 0 : i.inputs) == null || a.forEach((l) => {
    l.name && l.defaultValue !== void 0 && (o[l.name] = l.defaultValue);
  }), {
    ...o,
    ...s,
    ...t,
    ...n ? {
      locale: n
    } : {}
  };
}, Zs = ({
  content: e,
  data: t
}) => e ? {
  ...e,
  data: {
    ...e == null ? void 0 : e.data,
    ...t
  },
  meta: e == null ? void 0 : e.meta
} : void 0, er = pt, tr = f({
  name: "content-component",
  components: {
    EnableEditor: Gs,
    InlinedScript: Xe,
    ContentStyles: Qs,
    Blocks: J,
    DynamicDiv: G
  },
  props: [
    "content",
    "customComponents",
    "data",
    "locale",
    "context",
    "apiKey",
    "apiVersion",
    "blocksWrapper",
    "blocksWrapperProps",
    "model",
    "canTrack",
    "enrich",
    "showContent",
    "contentWrapper",
    "contentWrapperProps",
    "linkComponent",
    "trustedHosts",
    "isSsrAbTest",
    "isNestedRender"
  ],
  data() {
    var e, t;
    return {
      scriptStr: us({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        variationId: (e = this.content) == null ? void 0 : e.testVariationId,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        contentId: (t = this.content) == null ? void 0 : t.id
      }),
      registeredComponents: [
        ...ve(),
        ...this.customComponents || []
      ].reduce(
        (n, { component: o, ...s }) => ({
          ...n,
          [s.name]: {
            component: er(o),
            ...le(s)
          }
        }),
        {}
      ),
      builderContextSignal: {
        content: Zs({
          content: this.content,
          data: this.data
        }),
        localState: void 0,
        rootState: Xs({
          content: this.content,
          data: this.data,
          locale: this.locale
        }),
        rootSetState: this.contentSetState,
        context: this.context || {},
        apiKey: this.apiKey,
        apiVersion: this.apiVersion,
        componentInfos: [
          ...ve(),
          ...this.customComponents || []
        ].reduce(
          (n, { component: o, ...s }) => ({
            ...n,
            [s.name]: le(s)
          }),
          {}
        ),
        inheritedStyles: {},
        BlocksWrapper: this.blocksWrapper || "div",
        BlocksWrapperProps: this.blocksWrapperProps || {}
      },
      TARGET: V
    };
  },
  provide() {
    const e = this;
    return {
      [Pe.key]: {
        registeredComponents: e.registeredComponents
      }
    };
  },
  methods: {
    contentSetState(e) {
      this.builderContextSignal.rootState = e;
    }
  }
});
function nr(e, t, n, o, s, r) {
  const i = y("inlined-script"), a = y("content-styles"), l = y("blocks"), d = y("enable-editor");
  return u(), k(d, w({
    content: e.content,
    data: e.data,
    model: e.model,
    context: e.context,
    apiKey: e.apiKey,
    canTrack: e.canTrack,
    locale: e.locale,
    enrich: e.enrich,
    showContent: e.showContent,
    builderContextSignal: e.builderContextSignal,
    contentWrapper: e.contentWrapper,
    contentWrapperProps: e.contentWrapperProps,
    linkComponent: e.linkComponent,
    trustedHosts: e.trustedHosts
  }, {}), {
    default: B(() => {
      var m, c, p, v, g, N, Y;
      return [
        e.isSsrAbTest ? (u(), k(i, {
          key: 0,
          id: "builderio-variant-visibility",
          scriptStr: e.scriptStr
        }, null, 8, ["scriptStr"])) : S("", !0),
        e.TARGET !== "reactNative" ? (u(), k(a, {
          key: 1,
          isNestedRender: e.isNestedRender,
          contentId: (m = e.builderContextSignal.content) == null ? void 0 : m.id,
          cssCode: (p = (c = e.builderContextSignal.content) == null ? void 0 : c.data) == null ? void 0 : p.cssCode,
          customFonts: (g = (v = e.builderContextSignal.content) == null ? void 0 : v.data) == null ? void 0 : g.customFonts
        }, null, 8, ["isNestedRender", "contentId", "cssCode", "customFonts"])) : S("", !0),
        E(l, {
          blocks: (Y = (N = e.builderContextSignal.content) == null ? void 0 : N.data) == null ? void 0 : Y.blocks,
          context: e.builderContextSignal,
          registeredComponents: e.registeredComponents,
          linkComponent: e.linkComponent
        }, null, 8, ["blocks", "context", "registeredComponents", "linkComponent"])
      ];
    }),
    _: 1
  }, 16, ["content", "data", "model", "context", "apiKey", "canTrack", "locale", "enrich", "showContent", "builderContextSignal", "contentWrapper", "contentWrapperProps", "linkComponent", "trustedHosts"]);
}
const or = /* @__PURE__ */ b(tr, [["render", nr]]), sr = f({
  name: "content-variants",
  components: {
    InlinedScript: Xe,
    InlinedStyles: me,
    ContentComponent: or
  },
  props: [
    "canTrack",
    "content",
    "isNestedRender",
    "model",
    "data",
    "context",
    "apiKey",
    "apiVersion",
    "customComponents",
    "linkComponent",
    "locale",
    "enrich",
    "blocksWrapper",
    "blocksWrapperProps",
    "contentWrapper",
    "contentWrapperProps",
    "trustedHosts"
  ],
  data() {
    return {
      shouldRenderVariants: as({
        canTrack: z(this.canTrack),
        content: this.content
      }),
      TARGET: V,
      getInitVariantsFnsScriptString: cs,
      getVariants: Q
    };
  },
  mounted() {
  },
  computed: {
    updateCookieAndStylesScriptStr() {
      var e;
      return ds(
        Q(this.content).map((t) => ({
          id: t.testVariationId,
          testRatio: t.testRatio
        })),
        ((e = this.content) == null ? void 0 : e.id) || ""
      );
    },
    hideVariantsStyleString() {
      return Q(this.content).map((e) => `.variant-${e.testVariationId} { display: none; } `).join("");
    },
    defaultContent() {
      var e;
      return this.shouldRenderVariants ? {
        ...this.content,
        testVariationId: (e = this.content) == null ? void 0 : e.id
      } : Nn({
        item: this.content,
        canTrack: z(this.canTrack)
      });
    }
  }
});
function rr(e, t, n, o, s, r) {
  const i = y("inlined-script"), a = y("inlined-styles"), l = y("content-component");
  return u(), h($, null, [
    !e.isNestedRender && e.TARGET !== "reactNative" ? (u(), k(i, {
      key: 0,
      id: "builderio-init-variants-fns",
      scriptStr: e.getInitVariantsFnsScriptString()
    }, null, 8, ["scriptStr"])) : S("", !0),
    e.shouldRenderVariants ? (u(), h($, { key: 1 }, [
      E(a, {
        id: "builderio-variants",
        styles: e.hideVariantsStyleString
      }, null, 8, ["styles"]),
      E(i, {
        id: "builderio-variants-visibility",
        scriptStr: e.updateCookieAndStylesScriptStr
      }, null, 8, ["scriptStr"]),
      (u(!0), h($, null, O(e.getVariants(e.content), (d, m) => (u(), k(l, {
        key: d.testVariationId,
        isNestedRender: e.isNestedRender,
        content: d,
        showContent: !1,
        model: e.model,
        data: e.data,
        context: e.context,
        apiKey: e.apiKey,
        apiVersion: e.apiVersion,
        customComponents: e.customComponents,
        linkComponent: e.linkComponent,
        canTrack: e.canTrack,
        locale: e.locale,
        enrich: e.enrich,
        isSsrAbTest: e.shouldRenderVariants,
        blocksWrapper: e.blocksWrapper,
        blocksWrapperProps: e.blocksWrapperProps,
        contentWrapper: e.contentWrapper,
        contentWrapperProps: e.contentWrapperProps,
        trustedHosts: e.trustedHosts
      }, null, 8, ["isNestedRender", "content", "model", "data", "context", "apiKey", "apiVersion", "customComponents", "linkComponent", "canTrack", "locale", "enrich", "isSsrAbTest", "blocksWrapper", "blocksWrapperProps", "contentWrapper", "contentWrapperProps", "trustedHosts"]))), 128))
    ], 64)) : S("", !0),
    E(l, w({
      isNestedRender: e.isNestedRender,
      content: e.defaultContent,
      showContent: !0,
      model: e.model,
      data: e.data,
      context: e.context,
      apiKey: e.apiKey,
      apiVersion: e.apiVersion,
      customComponents: e.customComponents,
      linkComponent: e.linkComponent,
      canTrack: e.canTrack,
      locale: e.locale,
      enrich: e.enrich,
      isSsrAbTest: e.shouldRenderVariants,
      blocksWrapper: e.blocksWrapper,
      blocksWrapperProps: e.blocksWrapperProps,
      contentWrapper: e.contentWrapper,
      contentWrapperProps: e.contentWrapperProps,
      trustedHosts: e.trustedHosts
    }, {
      key: e.shouldRenderVariants.toString()
    }), null, 16, ["isNestedRender", "content", "model", "data", "context", "apiKey", "apiVersion", "customComponents", "linkComponent", "canTrack", "locale", "enrich", "isSsrAbTest", "blocksWrapper", "blocksWrapperProps", "contentWrapper", "contentWrapperProps", "trustedHosts"])
  ], 64);
}
const ir = /* @__PURE__ */ b(sr, [["render", rr]]), ar = async ({
  builderContextValue: e,
  symbol: t
}) => {
  if (t != null && t.model && // This is a hack, we should not need to check for this, but it is needed for Svelte.
  (e != null && e.apiKey))
    return be({
      model: t.model,
      apiKey: e.apiKey,
      apiVersion: e.apiVersion,
      ...(t == null ? void 0 : t.entry) && {
        query: {
          id: t.entry
        }
      }
    }).catch((n) => {
      R.error("Could not fetch symbol content: ", n);
    });
}, lr = f({
  name: "builder-symbol",
  components: { ContentVariants: ir, DynamicDiv: G },
  props: [
    "symbol",
    "attributes",
    "dynamic",
    "builderContext",
    "builderBlock",
    "builderComponents",
    "builderLinkComponent"
  ],
  data() {
    var e;
    return { contentToUse: (e = this.symbol) == null ? void 0 : e.content, filterAttrs: W };
  },
  mounted() {
    this.setContent();
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.setContent();
      },
      immediate: !0
    }
  },
  computed: {
    blocksWrapper() {
      return "div";
    },
    contentWrapper() {
      return "div";
    },
    className() {
      var e, t;
      return [
        this.attributes[ee()],
        "builder-symbol",
        (e = this.symbol) != null && e.inline ? "builder-inline-symbol" : void 0,
        (t = this.symbol) != null && t.dynamic || this.dynamic ? "builder-dynamic-symbol" : void 0
      ].filter(Boolean).join(" ");
    },
    onUpdateHook0() {
      return {
        0: this.symbol
      };
    }
  },
  methods: {
    setContent() {
      this.contentToUse || ar({
        symbol: this.symbol,
        builderContextValue: this.builderContext
      }).then((e) => {
        e && (this.contentToUse = e);
      });
    }
  }
});
function cr(e, t, n, o, s, r) {
  var a, l, d, m, c;
  const i = y("content-variants");
  return u(), h("div", w({ class: e.className }, { ...e.filterAttrs(e.attributes, "v-on:", !1) }, x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    E(i, {
      isNestedRender: !0,
      apiVersion: e.builderContext.apiVersion,
      apiKey: e.builderContext.apiKey,
      context: {
        ...e.builderContext.context,
        symbolId: (a = e.builderBlock) == null ? void 0 : a.id
      },
      customComponents: Object.values(e.builderComponents),
      data: {
        ...(l = e.symbol) == null ? void 0 : l.data,
        ...e.builderContext.localState,
        ...(m = (d = e.contentToUse) == null ? void 0 : d.data) == null ? void 0 : m.state
      },
      model: (c = e.symbol) == null ? void 0 : c.model,
      content: e.contentToUse,
      linkComponent: e.builderLinkComponent,
      blocksWrapper: e.blocksWrapper,
      contentWrapper: e.contentWrapper
    }, null, 8, ["apiVersion", "apiKey", "context", "customComponents", "data", "model", "content", "linkComponent", "blocksWrapper", "contentWrapper"])
  ], 16);
}
const dr = /* @__PURE__ */ b(lr, [["render", cr]]), Re = {};
function Sr(e) {
  if (T()) {
    Object.assign(Re, e);
    const t = {
      type: "builder.settingsChange",
      data: Re
    };
    parent.postMessage(t, "*");
  }
}
const Cr = async (e) => {
  var o, s, r;
  const t = e.path || ((o = e.url) == null ? void 0 : o.pathname) || ((s = e.userAttributes) == null ? void 0 : s.urlPath), n = {
    ...e,
    apiKey: e.apiKey,
    model: e.model || "page",
    userAttributes: {
      ...e.userAttributes,
      ...t ? {
        urlPath: t
      } : {}
    },
    options: et(e.searchParams || ((r = e.url) == null ? void 0 : r.searchParams) || e.options)
  };
  return {
    apiKey: n.apiKey,
    model: n.model,
    content: await be(n)
  };
};
export {
  ks as A,
  pe as B,
  un as C,
  vs as D,
  be as E,
  hn as F,
  hr as G,
  gr as H,
  Cn as I,
  $n as S,
  V as T,
  es as V,
  me as _,
  on as a,
  fr as b,
  U as c,
  yr as d,
  Fe as e,
  b as f,
  Ne as g,
  te as h,
  br as i,
  ee as j,
  ae as k,
  kt as l,
  dr as m,
  oo as n,
  J as o,
  ir as p,
  I as q,
  Ss as r,
  ns as s,
  Us as t,
  Sr as u,
  et as v,
  er as w,
  kr as x,
  vr as y,
  Cr as z
};
